// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:57:40.515Z
// Property: Somerset Oaks Apartment Homes (ID: 6767906449167611)
// Collections: 22 amenities, 6 floorplans (live), 52 photos, 77 POIs, 5 reviews, 6 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167611",
  "property_external_id": "1124184",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/somerset-oaks-apartment-homes-olathe-ks/713fykz/",
  "property_google_business_url": "https://www.google.com/maps/place/Somerset+Oaks+Apartment+Homes/@38.8942671,-94.7808002,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c095888292f3f7:0xf9d4632487d41da9!8m2!3d38.8942671!4d-94.7808002!16s%2Fg%2F113g404f9?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124184 p1099136",
  "property_status": null,
  "property_slug": "somerset-oaks-apartment-homes",
  "property_name": "Somerset Oaks Apartment Homes",
  "property_website_url": "https://www.somersetoaksapts.com/",
  "property_domain": "https://www.somersetoaksapts.com/",
  "property_address": "813 N Mur-Len Rd",
  "property_full_address": "813 N Mur-Len Rd, Olathe, KS 66062",
  "property_address_1": "813 N Mur-Len Rd",
  "property_address_2": null,
  "property_address_city": "Olathe",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66062",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Somerset Oaks Apartments",
  "property_address_latitude": "38.8936259",
  "property_address_longitude": "-94.7811332",
  "property_email": "rentcafe.so@pricekc.com",
  "property_phone": "(913) 578-3666",
  "property_call_tracking_phone": "913-578-3666",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Everyday ease meets Olathe convenience at Somerset Oaks.</strong> Explore one-, two-, and three-bedroom apartment homes with polished finishes, private outdoor space, and relaxed community comforts—then schedule your tour to see it in person.</p>",
  "property_long_description": "<p><strong>Somerset Oaks Apartment Homes pairs everyday ease with Olathe convenience.</strong> Choose from one-, two-, and three-bedroom apartment homes with details that make your space feel finished: 9-foot ceilings with crown molding, garden tubs, washer/dryer connections, private patios or balconies, spacious closets, and select features like plank flooring, fireplaces, built-in desks and bookshelves, mud rooms, extra storage, and direct-access or attached garages.</p><p>Outside your door, the community is built for comfortable routines and relaxed downtime, with a <a href=\"/amenities\">swimming pool with waterfall and sundeck</a>, wading pool, 24-hour fitness center, clubhouse, coffee bar, business center with wireless internet, picnic and grilling areas, package service, recycling, and on-site management and maintenance. From Somerset Oaks, you are near Main Event, AMC, Mahaffie Stagecoach Stop &amp; Farm, Ernie Miller Nature Park, everyday shopping and dining along the Mur-Len/127th Street corridor, and key Olathe destinations like Garmin and Olathe Medical Center. Explore the <a href=\"/floor-plans\">available floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-e0b4-719b-9e7b-ec6a868b9f50.webp",
  "property_featured_image_media": {
    "alt_text": "Living and dining area with a white sofa, coffee table, and dining set.",
    "public_id": "01a0b662-e0b4-719b-9e7b-ec6a868b9f50",
    "storage_key": "property/6767906449167611/01a0b662-e0b4-719b-9e7b-ec6a868b9f50.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "227",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.51101321585902",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://somersetoaksapts.securecafeapplicant.com/onlineleasing/content3/access/somerset-oaks0/floorplans",
  "property_resident_portal_url": "https://somersetoaksapts.securecafe.com/residentservices/somerset-oaks0/userlogin.aspx",
  "property_apply_now_url": "https://somersetoaksapts.securecafeapplicant.com/onlineleasing/content3/access/somerset-oaks0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-98ac-7287-906c-1d5cd1f0d4b2.webp",
  "property_primary_logo_media": {
    "alt_text": "Somerset Oaks Apartment Homes logo",
    "public_id": "019fc987-98ac-7287-906c-1d5cd1f0d4b2",
    "storage_key": "property/6767906449167611/019fc987-98ac-7287-906c-1d5cd1f0d4b2.webp",
    "width": 546,
    "height": 150
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc988-0484-74be-b4fc-fad2a4307308.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc988-0484-74be-b4fc-fad2a4307308",
    "storage_key": "property/6767906449167611/019fc988-0484-74be-b4fc-fad2a4307308.webp",
    "width": 546,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-f8a2-7676-9526-d963d3fc467a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc987-f8a2-7676-9526-d963d3fc467a",
    "storage_key": "property/6767906449167611/019fc987-f8a2-7676-9526-d963d3fc467a.webp",
    "width": 546,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#154734",
  "property_secondary_color": "#AD841F",
  "property_font_color": null,
  "property_color_4": "#78C0E0",
  "property_color_3": "#603140",
  "property_color_5": "#449DD1",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "672 - 1350",
  "property_sqft_min": "672",
  "property_sqft_max": "1350",
  "property_price_range": "1165 - 9125",
  "property_price_min": "1165",
  "property_price_max": "9125",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/SomersetOaksApts",
  "property_instagram_url": "https://www.instagram.com/somersetoaksapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9_OSgoiVwIcRqR3UhyRj1Pk",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Somerset Oaks Apartment Homes",
  "property_home_romance_title": "Embrace Life in Your Perfect Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Amenities that do more.</strong> Somerset Oaks Apartment Homes pairs everyday convenience with relaxed Olathe living: a 24-hour fitness center, business center with wireless internet, clubhouse coffee, and a swimming pool with waterfall and sundeck. Courtyards, picnic areas, and grills add more room to unwind, while select homes elevate the details with attached or direct-access garages, private patios or balconies, 9-foot ceilings with crown molding, garden tubs, fireplaces, built-in desks, mud rooms, and extra storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>One-, two-, and three-bedroom layouts with room to choose.</strong> Somerset Oaks Apartment Homes in Olathe offers floor plans from streamlined one-bedrooms to spacious two-bedroom designs and the expansive Somerset three-bedroom plan. Select homes add <strong>9-foot ceilings with crown molding</strong>, washer/dryer connections, garden tubs, patios or balconies, plank flooring, fireplaces, built-in desks, extra storage, and attached or direct-access garages.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Somerset Oaks.</strong> Preview sunlit interiors with crown molding, select plank-style flooring, and patios or balconies made for a quiet breath of fresh air. Then glimpse the clubhouse’s stone fireplace seating, coffee bar, business center, 24-hour fitness center, and a leafy pool courtyard with a waterfall, sundeck, and lounge chairs. Like what you see? The full gallery brings every detail into sharper focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Easy Olathe days start here.</strong> Somerset Oaks puts you near the 127th Street and Mur-Len corridor for coffee runs, takeout, errands, and entertainment close to home. Grab dinner at Tea Garden, catch a movie at AMC, or plan a night out at Main Event.</p><p>Nearby parks, trails, Mahaffie Stagecoach Stop &amp; Farm, and RideKC service at 127th and Mur-Len round out a location that keeps everyday plans simple.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents give Somerset Oaks high marks for service that shows.</strong> Reviews call out a helpful leasing team, professional maintenance, and requests handled quickly—sometimes within the hour. Add in well-kept grounds, spacious apartment homes, garages, a pool, and an Olathe location near shopping and dining, and it’s easy to see why one reviewer wrote, “10/10 recommend living here!” Read more to hear the experience in residents’ own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your days around an easy Olathe rhythm.</strong> From Somerset Oaks, you’re close to the everyday energy of the 127th Street and Mur-Len corridor, with quick stops for coffee, takeout, errands, and entertainment without going far from home. Head to Tea Garden for a neighborhood dinner, catch a movie at AMC, plan a night out at Main Event, or follow local history at Mahaffie Stagecoach Stop &amp; Farm.</p><p>When you want more fresh air, nearby Olathe parks and trails make it easy to trade screen time for open space, while RideKC service at 127th and Mur-Len adds another option for getting around Johnson County. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Start with the extras that simplify your routine.</strong> At Somerset Oaks Apartment Homes, amenities are designed to work as hard as they relax: a 24-hour fitness center for your schedule, a business center with wireless internet for focused tasks, and on-site management, maintenance, package service, and laundry facilities close at hand.</p><p>When it’s time to unwind, step out to the swimming pool with waterfall and sundeck, meet the day with coffee in the clubhouse, or enjoy the courtyard, picnic area, and grills. Inside select Olathe apartments, direct-access or attached garages, private patios or balconies, 9-foot ceilings with crown molding, garden tubs, fireplaces, plank flooring, built-in desks and bookshelves, mud rooms, and extra storage give your home a more polished, practical feel. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Somerset Oaks home?</strong> Start your application online for an Olathe apartment with polished everyday comforts, from 9-foot ceilings with crown molding to washer/dryer connections, spacious closets, and private patios or balconies. Choose your floor plan, apply with confidence, and take the next step toward easy, comfortable living.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Somerset Oaks leasing team for help with apartment availability, floor plan details, community features, or planning your visit to our Olathe location. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Have questions about Somerset Oaks?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and everyday living in Olathe. If you need more details or want to see the apartment homes in person, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day-to-day rhythm.</strong> Somerset Oaks Apartment Homes offers one-, two-, and three-bedroom floor plans in Olathe, with options that range from efficient and easy-to-maintain to generously sized with more room to spread out. Compare classic one-bedroom designs like Chelsea and Cheshire, two-bedroom layouts with one or two baths, and the expansive Somerset three-bedroom plan.</p><p>Inside, select homes add the details that make a floor plan feel more useful from the first week in: <strong>9-foot ceilings with crown molding</strong>, washer/dryer connections, garden tubs, private patios or balconies, spacious closets, plank flooring, fireplaces, built-in desks and bookshelves, mud rooms, extra storage, and attached or direct-access garages. Browse current availability, view the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See Somerset Oaks before you step inside.</strong> Browse photos that bring the community into focus: sunlit interiors with crown molding, open living spaces with plank-style flooring in select homes, and patios or balconies arranged for a quiet moment outside. In the clubhouse, stone fireplace seating and a coffee bar add warmth, while the business center and <a href=\"/amenities\">24-hour fitness center</a> show how everyday spaces are designed to be useful as well as inviting.</p><p>Outside, picture the swimming pool with its waterfall, lounge chairs, sundeck, and leafy courtyard setting. Then explore the apartment scenes that matter most to your routine—from kitchens and closets to garage access in select layouts—and compare <a href=\"/floor-plans\">available floor plans</a> when you find a look you love.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Somerset Oaks from the map.</strong> Check available apartments, then zoom out to see how Olathe convenience surrounds you—from the Mur-Len/127th Street corridor to nearby entertainment, nature, shopping, dining, Garmin, and Olathe Medical Center.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, purrs, and quiet hops.</strong> At Somerset Oaks Apartment Homes, cats, dogs, and rabbits can share your everyday routine without making pet care feel complicated. Step onto a private patio or balcony in select homes, keep leashes and supplies handy with spacious closets or extra storage options, and enjoy community courtyards, picnic areas, and grills when you want fresh air close to home. For bigger outings, Olathe offers nearby pet resources and open-air options, including Heritage Park’s off-leash dog area. Review the pet guidelines below, then explore our <a href=\"/floor-plans\">available floor plans</a> or see more <a href=\"/amenities\">community features</a> that help your home work for every member of the household.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Somerset Oaks?</strong> Share the everyday ease—finished apartment details, relaxing community spaces, and convenient Olathe access—with friends who should see it for themselves. Send a referral today and invite them to explore available one-, two-, and three-bedroom apartment homes.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Somerset Oaks.</strong><br>Take care of the everyday details in one convenient place—pay rent, submit maintenance requests, and manage your account with ease. With on-site management and maintenance supporting the community, your resident portal helps keep home routines simple.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Somerset Oaks Apartment Homes.</strong> Reviewers consistently highlight the people behind the community—from a leasing team that makes move-in feel simple to maintenance service described as “professional,” “quick,” and thorough.</p><p>You’ll see praise for well-kept grounds, spacious apartment homes, helpful office staff, and requests handled with care—sometimes within the hour. Residents also point to everyday conveniences like garages, the pool, and a location close to restaurants and shopping. As one reviewer put it: “10/10 recommend living here!” Browse the reviews below to get a real sense of the service, upkeep, and experience at Somerset Oaks.</p>",
  "property_created_at": "1785792488079",
  "property_scheduletour_blurb": "<p><strong>See Somerset Oaks in person.</strong> Tour one-, two-, and three-bedroom apartment homes with polished details like 9-foot ceilings, crown molding, garden tubs, spacious closets, and private patios or balconies. Explore the community’s relaxed spaces, then choose the <a href=\"/floor-plans\">floor plan</a> that fits your next move.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Somerset Oaks Apartment Homes.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture everyday ease in Olathe with spacious one-, two-, and three-bedroom homes, finished details, and comfortable community spaces designed for relaxed downtime.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Explore Somerset Oaks Apartment Homes from wherever you are with virtual tours of the Chelsea, Cheshire, Hampton, Yorkshire, Windsor, and Somerset apartment layouts. Move through one-, two-, and three-bedroom options in Olathe at your own pace, comparing how each home handles daily flow—from the kitchen and dining area to bedrooms, baths, closets, and the spots that make a layout feel more open.</p><p>As you tour, look for the details that help each floor plan stand out, such as crown molding, ceiling fans, garden tubs, private outdoor space, and select features like plank flooring, fireplaces, built-in desks or bookshelves, mud rooms, and garage access. When a favorite starts to click, compare <a href=\"/floor-plans\">floor plan availability</a> or <a href=\"/schedule-a-tour\">schedule an in-person tour</a> to see it up close.</p>",
  "property_copyright": "2026 All Rights Reserved. Somerset Oaks Apartment Homes",
  "property_seo_title_home": "Somerset Oaks Apartment Homes |  Apartments in Olathe, KS",
  "property_seo_description_home": "Experience luxury living at Somerset Oaks in Olathe, KS. Spacious 1-3 bedroom apartments with top-notch amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Olathe, KS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Somerset Oaks in Olathe, KS! Choose from stylish one, two, or three-bedroom floor plans. Your dream home awaits!",
  "property_seo_title_amenities": "Amenities | Olathe, KS Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Somerset Oaks in Olathe, KS. From spacious floor plans to delightful amenities like a pool, fitness center, and clubhouse—comfort awaits you!",
  "property_seo_title_gallery": "Gallery | Apartments in Olathe, KS",
  "property_seo_description_gallery": "Immerse yourself in luxury at Somerset Oaks in Olathe, KS. Enjoy stunning floor plans, resort-style amenities, and a vibrant community. Picture your life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Somerset Oaks Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Experience luxury living at Somerset Oaks in Olathe, KS. Take a virtual tour of our stylish one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Somerset Oaks Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Somerset Oaks in Olathe, KS. Use our interactive community map to explore spacious floor plans and discover top-notch amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Olathe, KS",
  "property_seo_description_neighborhood": "Uncover the vibrant Olathe neighborhood surrounding Somerset Oaks Apartment Homes. Dive into local favorites and hidden gems just steps from your front door!",
  "property_seo_title_contact": "Contact Us | Somerset Oaks Apartment Homes",
  "property_seo_description_contact": "Find your perfect home at Somerset Oaks in Olathe, KS. From cozy one-bedrooms to spacious three-bedrooms, our team is ready to assist you—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Olathe, KS",
  "property_seo_description_faqs": "Discover Somerset Oaks Apartments in Olathe, KS! Check our FAQs for details on amenities, floor plans, and community features. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Olathe, KS",
  "property_seo_description_reviews": "Experience the charm of Somerset Oaks in Olathe, KS! Read resident reviews and see why our vibrant community is the ideal place to call home. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Olathe, KS",
  "property_seo_description_applynow": "Discover your haven at Somerset Oaks, Olathe, KS! Enjoy modern amenities and spacious layouts. Apply online to elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Somerset Oaks Apartment Homes",
  "property_seo_description_residentaccess": "Seamlessly manage your life at Somerset Oaks in Olathe. Log in to your resident portal for rent payments, maintenance requests, and easy community access!",
  "property_seo_title_referafriend": "Refer A Friend | Somerset Oaks Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Somerset Oaks Apartment Homes in Olathe, KS! Great friends make great neighbors. Share the love of quality living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Somerset Oaks Apartment Homes",
  "property_seo_description_scheduletour": "Experience a home where comfort meets elegance at Somerset Oaks in Olathe, KS. Schedule your tour today and step into your future living space!",
  "property_seo_title_privacy": "Privacy Policy | Somerset Oaks Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Somerset Oaks. Dive into our policy to learn how we protect your information while you enjoy life in Olathe, KS.",
  "property_seo_title_accessibility": "Website Accessibility | Somerset Oaks Apartment Homes",
  "property_seo_description_accessibility": "At Somerset Oaks in Olathe, KS, accessibility is our priority. Experience inclusive living with features designed for everyone. Your comfort matters!",
  "property_seo_title_sitemap": "Sitemap | Somerset Oaks Apartment Homes",
  "property_seo_description_sitemap": "Navigate Somerset Oaks in Olathe, KS effortlessly! Check our sitemap for a quick overview of amenities, floor plans, and community features waiting for you.",
  "property_seo_title_thankyou": "Thank You | Somerset Oaks Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Somerset Oaks in Olathe, KS! Our team will connect soon to help you find your perfect apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Olathe, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628992860",
  "amenities": [
    {
      "id": "ec_e46fe78f49971af4bdb2dfeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847202",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-eebd-76ab-9362-4d6d4d728648.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living area with a stone fireplace, comfortable seating, and an open-concept kitchen.",
        "public_id": "01a0b662-eebd-76ab-9362-4d6d4d728648",
        "storage_key": "property/6767906449167611/01a0b662-eebd-76ab-9362-4d6d4d728648.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A living room with a stone fireplace and a brown leather couch. at Somerset Oaks Apartment Homes, Olathe, KS,A spacious kitchen with a central island and a ceiling fan. at Somerset Oaks Apartment Homes, Olathe, KS, 66062,A spacious room with a tiled floor and a chandelier hanging from the ceiling. at Somerset Oaks Apartment Homes, Kansas, 66062,A living room with a stone fireplace and two chairs. at Somerset Oaks Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cf375f74da517e8830fb889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847206",
      "title": "Swimming Pool with Waterfall & Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
      "amenity_image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and fountains, surrounded by apartment buildings.",
        "public_id": "01a0b662-ef60-72a9-baa2-6c0eed10c428",
        "storage_key": "property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A pool surrounded by lounge chairs and buildings in the background. at Somerset Oaks Apartment Homes, Olathe,A large swimming pool surrounded by trees and a building. at Somerset Oaks Apartment Homes, Olathe, Kansas,A large house with a pool in the backyard. at Somerset Oaks Apartment Homes, Olathe 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53e26c95261088c527152951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847207",
      "title": "Wading Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
      "amenity_image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "01a0b662-f16e-7129-ac4c-f2f5ef2f3e97",
        "storage_key": "property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A large swimming pool under a wooden pergola. at Somerset Oaks Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43b759cba4dc4d2e7f746144",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847201",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "01a0b662-ef12-751a-a0a8-9a31e93bbd3a",
        "storage_key": "property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A spacious gym with a variety of equipment including treadmills, weights, and a television. at Somerset Oaks Apartment Homes, Olathe, KS,A spacious gym with various exercise equipment and a ceiling fan. at Somerset Oaks Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25a0f67efb285e42d8104ed8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847205",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-eea9-75e8-8ecc-ccd963248cbb.webp",
      "amenity_image_media": {
        "alt_text": "Modern gray kitchen with stainless steel appliances and a coffee station.",
        "public_id": "01a0b662-eea9-75e8-8ecc-ccd963248cbb",
        "storage_key": "property/6767906449167611/01a0b662-eea9-75e8-8ecc-ccd963248cbb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a refrigerator on the right. at Somerset Oaks Apartment Homes, Olathe 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39b36cd5e5cdad9e419af781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847204",
      "title": "Business Center with Wireless Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-fc71-727f-bb85-0d494497dc55.webp",
      "amenity_image_media": {
        "alt_text": "Community dining room with a large wooden table and chairs.",
        "public_id": "01a0b662-fc71-727f-bb85-0d494497dc55",
        "storage_key": "property/6767906449167611/01a0b662-fc71-727f-bb85-0d494497dc55.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a dining room with a table and chairs and a ceiling fan at Somerset Oaks Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31c1043c7a7a90d98e77f81f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "125202532",
      "title": "Rentable Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking structure with multiple open spaces.",
        "public_id": "01a0b662-fe3f-72c7-be87-ffcf78f4690f",
        "storage_key": "property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "A large building with a grey roof and pillars is surrounded by trees. at Somerset Oaks Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c94092422c148793aa153eeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847203",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-fde9-7108-bf9b-99b59365d8a4.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers, exit sign above door.",
        "public_id": "01a0b662-fde9-7108-bf9b-99b59365d8a4",
        "storage_key": "property/6767906449167611/01a0b662-fde9-7108-bf9b-99b59365d8a4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a room filled with washes and dryers in front of a door at Somerset Oaks Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6eb7a4ccb99016f4f1caf29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "122755395",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e8fb9f9eed3e272c7863723",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847200",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09861691cde2907e5bf67ca3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "121253489",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
      "amenity_image_media": {
        "alt_text": "Spacious balcony with outdoor seating and lush plants, overlooking the community grounds.",
        "public_id": "01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a",
        "storage_key": "property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A balcony with a sofa, table, and potted plants. at Somerset Oaks Apartment Homes, Olathe, KS,A living room with a grey couch, a wooden coffee table, and a grey wall. at Somerset Oaks Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_950b38bc130eccda725c2b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847191",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec17cf1a1a3e8969cff24c4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "121431414",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c40bb9caf565b235b4c4f4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847197",
      "title": "Extra Storage*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f2ed25b4b77d5ff7165ec57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847189",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0030-77fb-88f2-508f372f7d3d.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a ceiling fan, walk-in closet, and a window with blinds.",
        "public_id": "01a0b663-0030-77fb-88f2-508f372f7d3d",
        "storage_key": "property/6767906449167611/01a0b663-0030-77fb-88f2-508f372f7d3d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a bedroom with a bed and a ceiling fan at Somerset Oaks Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecc77327ef5d4044e1b1595b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847196",
      "title": "Direct Access Garage*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-1ed6-7741-b90a-56e47cb61eef.webp",
      "amenity_image_media": {
        "alt_text": "Exterior of apartment building with attached garages.",
        "public_id": "01a0b663-1ed6-7741-b90a-56e47cb61eef",
        "storage_key": "property/6767906449167611/01a0b663-1ed6-7741-b90a-56e47cb61eef.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "three garage doors on the side of a house at Somerset Oaks Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ad51e5809728260a1054943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "121428811",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
      "amenity_image_media": {
        "alt_text": "Living and dining area of an apartment with green furniture.",
        "public_id": "01a0b663-0b58-7185-87f0-41f6dbe6683d",
        "storage_key": "property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A living room with a green couch and a wooden table. at Somerset Oaks Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f73b4e8f5ee4e966af18ac93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847187",
      "title": "9 Foot Ceilings with Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0cf2-73bf-b8a0-1a2ca2ad332a.webp",
      "amenity_image_media": {
        "alt_text": "Living room and dining area with white sofa, coffee table, dining table, and abstract art.",
        "public_id": "01a0b663-0cf2-73bf-b8a0-1a2ca2ad332a",
        "storage_key": "property/6767906449167611/01a0b663-0cf2-73bf-b8a0-1a2ca2ad332a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a living room with a couch and a table at Somerset Oaks Apartment Homes, Olathe, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73e115d52893982b19be4be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847193",
      "title": "Spacious Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0e60-76df-9430-e862bb0c558a.webp",
      "amenity_image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a0b663-0e60-76df-9430-e862bb0c558a",
        "storage_key": "property/6767906449167611/01a0b663-0e60-76df-9430-e862bb0c558a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Empty walk-in closet with white shelves and carpeted floor. at Somerset Oaks Apartment Homes, Olathe 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c97f66eec7651ef77eb3e75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847192",
      "title": "Mud Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_831e602f2c87fdcb9e2a0ec9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847188",
      "title": "Built In Desk & Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-263e-75ab-95f5-53568b2c3863.webp",
      "amenity_image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, desk, and large windows.",
        "public_id": "01a0b663-263e-75ab-95f5-53568b2c3863",
        "storage_key": "property/6767906449167611/01a0b663-263e-75ab-95f5-53568b2c3863.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a bedroom with a bed and a ceiling fan at Somerset Oaks Apartment Homes, Olathe 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_515096db11d30c3d557ed72b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "external_id": "87847198",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-2dfc-740e-8219-bf712cccf9c3.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and wood cabinets, next to a bathtub with a shower curtain.",
        "public_id": "01a0b663-2dfc-740e-8219-bf712cccf9c3",
        "storage_key": "property/6767906449167611/01a0b663-2dfc-740e-8219-bf712cccf9c3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bathroom with a white countertop and wooden cabinets. at Somerset Oaks Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e3d3b1686e2715d78634a419",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-e0b4-719b-9e7b-ec6a868b9f50.webp",
      "image_media": {
        "alt_text": "Living and dining area with a white sofa, coffee table, and dining set.",
        "public_id": "01a0b662-e0b4-719b-9e7b-ec6a868b9f50",
        "storage_key": "property/6767906449167611/01a0b662-e0b4-719b-9e7b-ec6a868b9f50.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern furnishings and ample natural light.",
      "link": "false",
      "alt_text": "Living and dining area with a white sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-813 N Mur-Len Rd-10 copy_final(1).jpg"
    },
    {
      "id": "ec_25be3f076ee3e52053b31a52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-396b-77d6-bf94-deabbca36eb0.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, desk, and large window.",
        "public_id": "01a0b663-396b-77d6-bf94-deabbca36eb0",
        "storage_key": "property/6767906449167611/01a0b663-396b-77d6-bf94-deabbca36eb0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a dedicated workspace with a desk, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, desk, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-813 N Mur-Len Rd-16 copy_final(1).jpg"
    },
    {
      "id": "ec_4258bc6815e34680e00cf1f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-3b37-71dd-8b2b-6e081d0dc720.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, and black stove.",
        "public_id": "01a0b663-3b37-71dd-8b2b-6e081d0dc720",
        "storage_key": "property/6767906449167611/01a0b663-3b37-71dd-8b2b-6e081d0dc720.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, a full-size refrigerator, and a stove with a vent hood. Perfect for home-cooked meals.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white refrigerator, and black stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-813 N Mur-Len Rd-13 copy_final(1).jpg"
    },
    {
      "id": "ec_1dee4ff805bc601f9b5c66e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-3a5f-70a7-a980-03e99421bd5c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a dining table and chairs, a sofa, a coffee table, and a television mounted on the wall.",
        "public_id": "01a0b663-3a5f-70a7-a980-03e99421bd5c",
        "storage_key": "property/6767906449167611/01a0b663-3a5f-70a7-a980-03e99421bd5c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a modern kitchen, perfect for entertaining guests or relaxing after a long day.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a dining table and chairs, a sofa, a coffee table, and a television mounted on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-813 N Mur-Len Rd-11 copy_final(1).jpg"
    },
    {
      "id": "ec_eaa4f6fc7eafbbfaf294eb26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-39bd-74bd-983d-1ecf19671380.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and an island.",
        "public_id": "01a0b663-39bd-74bd-983d-1ecf19671380",
        "storage_key": "property/6767906449167611/01a0b663-39bd-74bd-983d-1ecf19671380.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring dark cabinetry, a spacious island with a white countertop, and stainless steel appliances. Perfect for entertaining or everyday living.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-813 N Mur-Len Rd-2(1).jpg"
    },
    {
      "id": "ec_6a6726a23bf841602fe9ffe2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-3a16-726c-bf77-4418f2d8c41d.webp",
      "image_media": {
        "alt_text": "Living and dining area with a view of the kitchen.",
        "public_id": "01a0b663-3a16-726c-bf77-4418f2d8c41d",
        "storage_key": "property/6767906449167611/01a0b663-3a16-726c-bf77-4418f2d8c41d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and spacious living and dining area featuring a modern dining set and a glimpse into the open kitchen space. Perfect for entertaining and comfortable living.",
      "link": "false",
      "alt_text": "Living and dining area with a view of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-813 N Mur-Len Rd-12 copy_final(1).jpg"
    },
    {
      "id": "ec_3f59d70188866ef3815cbcbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-5cb2-77c4-8ac0-b1c0c4a01ac5.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, closet, and ceiling fan.",
        "public_id": "01a0b663-5cb2-77c4-8ac0-b1c0c4a01ac5",
        "storage_key": "property/6767906449167611/01a0b663-5cb2-77c4-8ac0-b1c0c4a01ac5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and a ceiling fan for climate control. The room is bright and airy with a large window.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, closet, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-813 N Mur-Len Rd-17 copy_final(1).jpg"
    },
    {
      "id": "ec_9adee22f12b7c050371c7366",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-48ee-7233-9024-a9ba1c693bbb.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with white countertop and sink, wood cabinets, and mirror with lights.",
        "public_id": "01a0b663-48ee-7233-9024-a9ba1c693bbb",
        "storage_key": "property/6767906449167611/01a0b663-48ee-7233-9024-a9ba1c693bbb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a vanity with ample counter space, a sink, and plenty of storage in the wood cabinets.",
      "link": "false",
      "alt_text": "Bathroom vanity with white countertop and sink, wood cabinets, and mirror with lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-813 N Mur-Len Rd-19 copy_final(1).jpg"
    },
    {
      "id": "ec_38160183ef0c8c63cae9a048",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-4ac7-74c9-a11c-518e9746f756.webp",
      "image_media": {
        "alt_text": "Bathroom with wood cabinets, white vanity, toilet, and shower/tub combo.",
        "public_id": "01a0b663-4ac7-74c9-a11c-518e9746f756",
        "storage_key": "property/6767906449167611/01a0b663-4ac7-74c9-a11c-518e9746f756.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring ample storage, a vanity with a pristine white countertop, and a clean shower/tub combination.",
      "link": "false",
      "alt_text": "Bathroom with wood cabinets, white vanity, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-813 N Mur-Len Rd-18 copy_final(1).jpg"
    },
    {
      "id": "ec_6f9bc3ae2b044b2bad4c1ff5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-4a9f-716d-98ff-2606e25393fb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark gray cabinets, stainless steel appliances, and a large refrigerator.",
        "public_id": "01a0b663-4a9f-716d-98ff-2606e25393fb",
        "storage_key": "property/6767906449167611/01a0b663-4a9f-716d-98ff-2606e25393fb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed kitchen featuring dark gray cabinetry, white countertops, and top-of-the-line stainless steel appliances, including a refrigerator with an ice dispenser.",
      "link": "false",
      "alt_text": "Modern kitchen with dark gray cabinets, stainless steel appliances, and a large refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-813 N Mur-Len Rd-3(1).jpg"
    },
    {
      "id": "ec_a77dd99455337b018ebb972f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-4acf-732a-b553-ff24e37eea22.webp",
      "image_media": {
        "alt_text": "Living room area with a stone fireplace and seating.",
        "public_id": "01a0b663-4acf-732a-b553-ff24e37eea22",
        "storage_key": "property/6767906449167611/01a0b663-4acf-732a-b553-ff24e37eea22.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Cozy living room area featuring a large stone fireplace, comfortable seating, and elegant decor. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Living room area with a stone fireplace and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-813 N Mur-Len Rd-7(3).jpg"
    },
    {
      "id": "ec_7830b875bc721dacd7b9f038",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-5470-73aa-9e07-d60ec6834abd.webp",
      "image_media": {
        "alt_text": "Elegant lobby with reception desk, seating area, and double doors leading outside.",
        "public_id": "01a0b663-5470-73aa-9e07-d60ec6834abd",
        "storage_key": "property/6767906449167611/01a0b663-5470-73aa-9e07-d60ec6834abd.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to our beautifully designed lobby, featuring a modern reception desk and comfortable seating. The spacious entrance provides a warm greeting and easy access to the outdoors.",
      "link": "false",
      "alt_text": "Elegant lobby with reception desk, seating area, and double doors leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-813 N Mur-Len Rd-8(3).jpg"
    },
    {
      "id": "ec_83f47b3c260b76335ccf44b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-6c9c-768d-a503-680be6e47148.webp",
      "image_media": {
        "alt_text": "Spacious living area with a stone fireplace, comfortable seating, and a modern kitchen in the background.",
        "public_id": "01a0b663-6c9c-768d-a503-680be6e47148",
        "storage_key": "property/6767906449167611/01a0b663-6c9c-768d-a503-680be6e47148.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed living area, featuring a cozy stone fireplace and a sleek, modern kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Spacious living area with a stone fireplace, comfortable seating, and a modern kitchen in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-813 N Mur-Len Rd-4(1).jpg"
    },
    {
      "id": "ec_10b99589833f6b369e6dfa35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-6cd6-700e-9b68-caa0f0ca07c1.webp",
      "image_media": {
        "alt_text": "Community dining room with large table and chairs.",
        "public_id": "01a0b663-6cd6-700e-9b68-caa0f0ca07c1",
        "storage_key": "property/6767906449167611/01a0b663-6cd6-700e-9b68-caa0f0ca07c1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather in the elegant community dining room, perfect for hosting events or enjoying a meal with neighbors.",
      "link": "false",
      "alt_text": "Community dining room with large table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-813 N Mur-Len Rd-5(1).jpg"
    },
    {
      "id": "ec_975d3262b9b7fff36ae93f1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-58a7-71bb-afcc-344bac5ba993.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washing machines and dryers, exit sign above a glass door.",
        "public_id": "01a0b663-58a7-71bb-afcc-344bac5ba993",
        "storage_key": "property/6767906449167611/01a0b663-58a7-71bb-afcc-344bac5ba993.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities featuring multiple washing machines and dryers for resident use.",
      "link": "false",
      "alt_text": "Laundry room with rows of washing machines and dryers, exit sign above a glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-813 N Mur-Len Rd-6(1).jpg"
    },
    {
      "id": "ec_b719ed4fd1e6378fe5e7389b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-748d-76f6-a115-ecf81281b8ca.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and a pantry.",
        "public_id": "01a0b663-748d-76f6-a115-ecf81281b8ca",
        "storage_key": "property/6767906449167611/01a0b663-748d-76f6-a115-ecf81281b8ca.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample storage with wooden cabinetry and a walk-in pantry. Includes modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and a pantry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-813 N Mur-Len Rd-13 copy_final(2).jpg"
    },
    {
      "id": "ec_b3486f18ab807f6726a09da8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-748d-76f6-a115-ecf81281b8ca.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and a pantry.",
        "public_id": "01a0b663-748d-76f6-a115-ecf81281b8ca",
        "storage_key": "property/6767906449167611/01a0b663-748d-76f6-a115-ecf81281b8ca.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample storage with wooden cabinetry and a walk-in pantry. Includes modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and a pantry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-813 N Mur-Len Rd-13 copy_final(2).jpg"
    },
    {
      "id": "ec_2b6691649a1d36dc2f3dee3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-7c25-7209-a8c0-ee4e1ffe78c8.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with a modern kitchen.",
        "public_id": "01a0b663-7c25-7209-a8c0-ee4e1ffe78c8",
        "storage_key": "property/6767906449167611/01a0b663-7c25-7209-a8c0-ee4e1ffe78c8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience spacious living in this open-concept apartment, featuring a sleek kitchen and a comfortable dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "Open concept living and dining area with a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-813 N Mur-Len Rd-15 copy_final.jpg"
    },
    {
      "id": "ec_91d362193700664fcf3717f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-7c25-7209-a8c0-ee4e1ffe78c8.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with a modern kitchen.",
        "public_id": "01a0b663-7c25-7209-a8c0-ee4e1ffe78c8",
        "storage_key": "property/6767906449167611/01a0b663-7c25-7209-a8c0-ee4e1ffe78c8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience spacious living in this open-concept apartment, featuring a sleek kitchen and a comfortable dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "Open concept living and dining area with a modern kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-813 N Mur-Len Rd-15 copy_final.jpg"
    },
    {
      "id": "ec_5aec45a1d34e5a3edb0d9493",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
      "image_media": {
        "alt_text": "Living and dining area of an apartment with green furniture.",
        "public_id": "01a0b663-0b58-7185-87f0-41f6dbe6683d",
        "storage_key": "property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a plush green sectional sofa, elegant dining set, and large windows. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living and dining area of an apartment with green furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-813 N Mur-Len Rd-14 copy_final.jpg"
    },
    {
      "id": "ec_3c644dbd6dee96f9166a2216",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
      "image_media": {
        "alt_text": "Living and dining area of an apartment with green furniture.",
        "public_id": "01a0b663-0b58-7185-87f0-41f6dbe6683d",
        "storage_key": "property/6767906449167611/01a0b663-0b58-7185-87f0-41f6dbe6683d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a plush green sectional sofa, elegant dining set, and large windows. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Living and dining area of an apartment with green furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-813 N Mur-Len Rd-14 copy_final.jpg"
    },
    {
      "id": "ec_926472886652a3521b94a14d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-2dfc-740e-8219-bf712cccf9c3.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and wood cabinets, next to a bathtub with a shower curtain.",
        "public_id": "01a0b663-2dfc-740e-8219-bf712cccf9c3",
        "storage_key": "property/6767906449167611/01a0b663-2dfc-740e-8219-bf712cccf9c3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A bright and clean apartment bathroom featuring a spacious vanity with ample counter space, a large mirror, and wood cabinetry. Includes a bathtub with a decorative shower curtain.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and wood cabinets, next to a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-813 N Mur-Len Rd-11 copy_final.jpg"
    },
    {
      "id": "ec_2c10ed7aa6be18cafa00b1a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-8bda-701f-bf3b-2acf22e7bdee.webp",
      "image_media": {
        "alt_text": "Multiple garage doors for residents.",
        "public_id": "01a0b663-8bda-701f-bf3b-2acf22e7bdee",
        "storage_key": "property/6767906449167611/01a0b663-8bda-701f-bf3b-2acf22e7bdee.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Secure and convenient garage parking is available for residents.",
      "link": "false",
      "alt_text": "Multiple garage doors for residents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-813 N Mur-Len Rd-23(1).jpg"
    },
    {
      "id": "ec_97640da8501318ee8ab8bae7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-8c14-73cd-a150-eeb912d9bedc.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with multiple garage doors and a balcony.",
        "public_id": "01a0b663-8c14-73cd-a150-eeb912d9bedc",
        "storage_key": "property/6767906449167611/01a0b663-8c14-73cd-a150-eeb912d9bedc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing its facade, complete with several garage doors and a private balcony, offering a glimpse into the property's community features.",
      "link": "false",
      "alt_text": "Apartment building exterior with multiple garage doors and a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-813 N Mur-Len Rd-22(1).jpg"
    },
    {
      "id": "ec_e8d0c48f49a6dd6fddf17e73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
      "image_media": {
        "alt_text": "Covered parking structure with multiple open spaces.",
        "public_id": "01a0b662-fe3f-72c7-be87-ffcf78f4690f",
        "storage_key": "property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Park your vehicle in our convenient covered parking spaces, offering protection from the elements.",
      "link": "false",
      "alt_text": "Covered parking structure with multiple open spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-813 N Mur-Len Rd-18.jpg"
    },
    {
      "id": "ec_18f39bad1e693bca39ea56c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
      "image_media": {
        "alt_text": "Covered parking structure with multiple open spaces.",
        "public_id": "01a0b662-fe3f-72c7-be87-ffcf78f4690f",
        "storage_key": "property/6767906449167611/01a0b662-fe3f-72c7-be87-ffcf78f4690f.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Park your vehicle in our convenient covered parking spaces, offering protection from the elements.",
      "link": "false",
      "alt_text": "Covered parking structure with multiple open spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-813 N Mur-Len Rd-18.jpg"
    },
    {
      "id": "ec_c6226e012f551e9c16e737a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-807c-74ac-ae7a-bbb43e4210b9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and brick accents.",
        "public_id": "01a0b663-807c-74ac-ae7a-bbb43e4210b9",
        "storage_key": "property/6767906449167611/01a0b663-807c-74ac-ae7a-bbb43e4210b9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing a blend of gray siding and red brick, featuring balconies and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and brick accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-813 N Mur-Len Rd-21.jpg"
    },
    {
      "id": "ec_4178362da4d006002e655fd6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-807c-74ac-ae7a-bbb43e4210b9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and brick accents.",
        "public_id": "01a0b663-807c-74ac-ae7a-bbb43e4210b9",
        "storage_key": "property/6767906449167611/01a0b663-807c-74ac-ae7a-bbb43e4210b9.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing a blend of gray siding and red brick, featuring balconies and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and brick accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-813 N Mur-Len Rd-21.jpg"
    },
    {
      "id": "ec_37ee1b77a706724a68662db5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-9bda-725a-aae1-04b164d8cf34.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and grounds with a paved walkway leading to a building entrance.",
        "public_id": "01a0b663-9bda-725a-aae1-04b164d8cf34",
        "storage_key": "property/6767906449167611/01a0b663-9bda-725a-aae1-04b164d8cf34.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Welcome to your new home! This beautifully maintained community offers a serene environment with lush green spaces and attractive building exteriors. Enjoy the convenience of well-paved walkways connecting you to our charming apartment buildings.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings and grounds with a paved walkway leading to a building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-813 N Mur-Len Rd-19.jpg"
    },
    {
      "id": "ec_e72f2c882b5d23b46f88a1c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-9bda-725a-aae1-04b164d8cf34.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings and grounds with a paved walkway leading to a building entrance.",
        "public_id": "01a0b663-9bda-725a-aae1-04b164d8cf34",
        "storage_key": "property/6767906449167611/01a0b663-9bda-725a-aae1-04b164d8cf34.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Welcome to your new home! This beautifully maintained community offers a serene environment with lush green spaces and attractive building exteriors. Enjoy the convenience of well-paved walkways connecting you to our charming apartment buildings.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings and grounds with a paved walkway leading to a building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-813 N Mur-Len Rd-19.jpg"
    },
    {
      "id": "ec_6a77eef3988a0396d489f242",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-8a8b-759d-8b98-3ceff0166eef.webp",
      "image_media": {
        "alt_text": "Manicured lawn with a lamp post in front of apartment buildings and a playground.",
        "public_id": "01a0b663-8a8b-759d-8b98-3ceff0166eef",
        "storage_key": "property/6767906449167611/01a0b663-8a8b-759d-8b98-3ceff0166eef.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our beautifully maintained grounds, perfect for relaxing or playing outdoors.",
      "link": "false",
      "alt_text": "Manicured lawn with a lamp post in front of apartment buildings and a playground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-813 N Mur-Len Rd-20.jpg"
    },
    {
      "id": "ec_fb3d96098cfb838d868a13ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-8a8b-759d-8b98-3ceff0166eef.webp",
      "image_media": {
        "alt_text": "Manicured lawn with a lamp post in front of apartment buildings and a playground.",
        "public_id": "01a0b663-8a8b-759d-8b98-3ceff0166eef",
        "storage_key": "property/6767906449167611/01a0b663-8a8b-759d-8b98-3ceff0166eef.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our beautifully maintained grounds, perfect for relaxing or playing outdoors.",
      "link": "false",
      "alt_text": "Manicured lawn with a lamp post in front of apartment buildings and a playground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-813 N Mur-Len Rd-20.jpg"
    },
    {
      "id": "ec_f1758f5cc636febac5e45f30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
      "image_media": {
        "alt_text": "Spacious balcony with outdoor seating and lush plants, overlooking the community grounds.",
        "public_id": "01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a",
        "storage_key": "property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening unwind on this expansive balcony, perfect for relaxing and enjoying the view.",
      "link": "false",
      "alt_text": "Spacious balcony with outdoor seating and lush plants, overlooking the community grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-813 N Mur-Len Rd-17 copy_final.jpg"
    },
    {
      "id": "ec_979b106d8cb649942e6fbbb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
      "image_media": {
        "alt_text": "Spacious balcony with outdoor seating and lush plants, overlooking the community grounds.",
        "public_id": "01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a",
        "storage_key": "property/6767906449167611/01a0b662-ff6d-70ad-9cc7-ccc6b7b8e35a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening unwind on this expansive balcony, perfect for relaxing and enjoying the view.",
      "link": "false",
      "alt_text": "Spacious balcony with outdoor seating and lush plants, overlooking the community grounds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-813 N Mur-Len Rd-17 copy_final.jpg"
    },
    {
      "id": "ec_d4741509a0ec27e57582821b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-ab6a-7589-8ecd-c61f48360792.webp",
      "image_media": {
        "alt_text": "Balcony with seating and coffee table",
        "public_id": "01a0b663-ab6a-7589-8ecd-c61f48360792",
        "storage_key": "property/6767906449167611/01a0b663-ab6a-7589-8ecd-c61f48360792.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony, perfect for relaxing or entertaining. Features comfortable seating and a stylish coffee table.",
      "link": "false",
      "alt_text": "Balcony with seating and coffee table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-813 N Mur-Len Rd-16 copy_final.jpg"
    },
    {
      "id": "ec_f5decceee96155a9ff3ca459",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-ab6a-7589-8ecd-c61f48360792.webp",
      "image_media": {
        "alt_text": "Balcony with seating and coffee table",
        "public_id": "01a0b663-ab6a-7589-8ecd-c61f48360792",
        "storage_key": "property/6767906449167611/01a0b663-ab6a-7589-8ecd-c61f48360792.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony, perfect for relaxing or entertaining. Features comfortable seating and a stylish coffee table.",
      "link": "false",
      "alt_text": "Balcony with seating and coffee table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-813 N Mur-Len Rd-16 copy_final.jpg"
    },
    {
      "id": "ec_efd4248ae8d92664dad85a78",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-96ea-72bb-af24-72471aa61388.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under a pergola.",
        "public_id": "01a0b663-96ea-72bb-af24-72471aa61388",
        "storage_key": "property/6767906449167611/01a0b663-96ea-72bb-af24-72471aa61388.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge seating and shaded areas perfect for relaxing.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-813 N Mur-Len Rd-3(2).jpg"
    },
    {
      "id": "ec_cd8f3d90ae0426d35802ed5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-96ea-72bb-af24-72471aa61388.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under a pergola.",
        "public_id": "01a0b663-96ea-72bb-af24-72471aa61388",
        "storage_key": "property/6767906449167611/01a0b663-96ea-72bb-af24-72471aa61388.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge seating and shaded areas perfect for relaxing.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under a pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-813 N Mur-Len Rd-3(2).jpg"
    },
    {
      "id": "ec_fa7837f15381121469d04580",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-99a1-736b-9b28-06e495edc6c3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a brick building.",
        "public_id": "01a0b663-99a1-736b-9b28-06e495edc6c3",
        "storage_key": "property/6767906449167611/01a0b663-99a1-736b-9b28-06e495edc6c3.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a brick building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-813 N Mur-Len Rd-6(4).jpg"
    },
    {
      "id": "ec_6e7ce9a7a93d0495abe698b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "01a0b662-f16e-7129-ac4c-f2f5ef2f3e97",
        "storage_key": "property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and a shaded pergola, offering the perfect oasis for your leisure time.",
      "link": "false",
      "alt_text": "Luxurious swimming pool with lounge chairs and a pergola at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-813 N Mur-Len Rd-2(3).jpg"
    },
    {
      "id": "ec_b6d81be5b2e0722b99741745",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-bb11-7165-9039-90580735f974.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "01a0b663-bb11-7165-9039-90580735f974",
        "storage_key": "property/6767906449167611/01a0b663-bb11-7165-9039-90580735f974.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a shaded seating area for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-813 N Mur-Len Rd-4(3).jpg"
    },
    {
      "id": "ec_8a7729d114307328326b9d36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-bb11-7165-9039-90580735f974.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "01a0b663-bb11-7165-9039-90580735f974",
        "storage_key": "property/6767906449167611/01a0b663-bb11-7165-9039-90580735f974.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a shaded seating area for relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-813 N Mur-Len Rd-4(3).jpg"
    },
    {
      "id": "ec_f3502fe56a2c9d19d61c74eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and fountains, surrounded by apartment buildings.",
        "public_id": "01a0b662-ef60-72a9-baa2-6c0eed10c428",
        "storage_key": "property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool, complete with comfortable lounge chairs and relaxing fountains. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Sparkling swimming pool with lounge chairs and fountains, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-813 N Mur-Len Rd-1(4).jpg"
    },
    {
      "id": "ec_3ee0d113016136161e2ab179",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and fountains, surrounded by apartment buildings.",
        "public_id": "01a0b662-ef60-72a9-baa2-6c0eed10c428",
        "storage_key": "property/6767906449167611/01a0b662-ef60-72a9-baa2-6c0eed10c428.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool, complete with comfortable lounge chairs and relaxing fountains. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Sparkling swimming pool with lounge chairs and fountains, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-813 N Mur-Len Rd-1(4).jpg"
    },
    {
      "id": "ec_790856c69a8e8ce0cde618ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and a pergola at a multifamily property.",
        "public_id": "01a0b662-f16e-7129-ac4c-f2f5ef2f3e97",
        "storage_key": "property/6767906449167611/01a0b662-f16e-7129-ac4c-f2f5ef2f3e97.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and a shaded pergola, offering the perfect oasis for your leisure time.",
      "link": "false",
      "alt_text": "Luxurious swimming pool with lounge chairs and a pergola at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-813 N Mur-Len Rd-2(3).jpg"
    },
    {
      "id": "ec_4e06ea41070fdd7901097f6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-99a1-736b-9b28-06e495edc6c3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and a brick building.",
        "public_id": "01a0b663-99a1-736b-9b28-06e495edc6c3",
        "storage_key": "property/6767906449167611/01a0b663-99a1-736b-9b28-06e495edc6c3.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and a brick building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-813 N Mur-Len Rd-6(4).jpg"
    },
    {
      "id": "ec_aab46ef41a25bd2f8687133c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "01a0b662-ef12-751a-a0a8-9a31e93bbd3a",
        "storage_key": "property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center gym with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-813 N Mur-Len Rd-10.jpg"
    },
    {
      "id": "ec_8b0a47aac03387d3ed08a317",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, free weights, and exercise balls.",
        "public_id": "01a0b662-ef12-751a-a0a8-9a31e93bbd3a",
        "storage_key": "property/6767906449167611/01a0b662-ef12-751a-a0a8-9a31e93bbd3a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center gym with treadmills, weight machines, free weights, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-813 N Mur-Len Rd-10.jpg"
    },
    {
      "id": "ec_e11d9fe04d0aa6eceae15f2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-5470-73aa-9e07-d60ec6834abd.webp",
      "image_media": {
        "alt_text": "Elegant lobby with reception desk, seating area, and double doors leading outside.",
        "public_id": "01a0b663-5470-73aa-9e07-d60ec6834abd",
        "storage_key": "property/6767906449167611/01a0b663-5470-73aa-9e07-d60ec6834abd.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to our beautifully designed lobby, featuring a modern reception desk and comfortable seating. The spacious entrance provides a warm greeting and easy access to the outdoors.",
      "link": "false",
      "alt_text": "Elegant lobby with reception desk, seating area, and double doors leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-813 N Mur-Len Rd-8(3).jpg"
    },
    {
      "id": "ec_e409e66b51defb0068241492",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-4acf-732a-b553-ff24e37eea22.webp",
      "image_media": {
        "alt_text": "Living room area with a stone fireplace and seating.",
        "public_id": "01a0b663-4acf-732a-b553-ff24e37eea22",
        "storage_key": "property/6767906449167611/01a0b663-4acf-732a-b553-ff24e37eea22.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Cozy living room area featuring a large stone fireplace, comfortable seating, and elegant decor. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Living room area with a stone fireplace and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-813 N Mur-Len Rd-7(3).jpg"
    },
    {
      "id": "ec_ad9f0a87b53384f2f1828b44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-c2ea-77fa-b6f8-359aafb545b8.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with weight machines, treadmills, ellipticals, and weight racks.",
        "public_id": "01a0b663-c2ea-77fa-b6f8-359aafb545b8",
        "storage_key": "property/6767906449167611/01a0b663-c2ea-77fa-b6f8-359aafb545b8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with weight machines, treadmills, ellipticals, and weight racks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-813 N Mur-Len Rd-9(3).jpg"
    },
    {
      "id": "ec_44a2901656e281abcab89e7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-c2ea-77fa-b6f8-359aafb545b8.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with weight machines, treadmills, ellipticals, and weight racks.",
        "public_id": "01a0b663-c2ea-77fa-b6f8-359aafb545b8",
        "storage_key": "property/6767906449167611/01a0b663-c2ea-77fa-b6f8-359aafb545b8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fully equipped fitness center with weight machines, treadmills, ellipticals, and weight racks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-813 N Mur-Len Rd-9(3).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_55fa33d8-7da2-4e61-a821-b05b541b08c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "POUR Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "11120 S Lone Elm Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Relaxed coffee shop for caffeine drinks and gluten-free pastries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-51fc-747d-9d48-1666a834f546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-51fc-747d-9d48-1666a834f546",
        "storage_key": "property/6767906449167611/019fc98a-51fc-747d-9d48-1666a834f546.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.pourcoffeekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5174039447814149888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pour-coffeehouse",
      "poi_latitude": "38.9264498",
      "poi_longitude": "-94.8370734",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-839-9736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-98b3-740f-bab8-064a27f90dc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-98b3-740f-bab8-064a27f90dc4",
        "storage_key": "property/6767906449167611/019fc98a-98b3-740f-bab8-064a27f90dc4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJFVZE416WwIcRABfS7HbhzUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_71c84ac1-7c23-42c4-b8a6-090f55127cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Sakura Japanese Sushi Train II",
      "poi_type": "Restaurants",
      "poi_address": "1109 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Relaxed, contemporary Japanese restaurant specializing in conveyor-belt sushi carried by trains.",
      "poi_long_description": "Relaxed, contemporary Japanese restaurant specializing in conveyor-belt sushi carried by trains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-5c11-710f-9482-aec364cf292b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-5c11-710f-9482-aec364cf292b",
        "storage_key": "property/6767906449167611/019ff6ad-5c11-710f-9482-aec364cf292b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sakurasushitrain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3543710235105376509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sakura-japanese-sushi-train-ii",
      "poi_latitude": "38.883354",
      "poi_longitude": "-94.7998249",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-839-8893",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWvnURu-wIcR_Thf9q7JLTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_d071b717-d6ad-472e-ac27-d47e1827a870",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "1731 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Long-standing bar and grill serving burgers, wraps, sandwiches, salads, nachos and chicken wings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-457d-73cd-af18-6d4f9fcb797a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-457d-73cd-af18-6d4f9fcb797a",
        "storage_key": "property/6767906449167611/019fc98a-457d-73cd-af18-6d4f9fcb797a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://peanutmidwest.com/the-peanut-on-s-mur-len-rd-olathe-ks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13303166440226011406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "38.8556625",
      "poi_longitude": "-94.7804693",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-839-1579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrz1Z_2S_wIcRDrmR6WRXnrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_06754cb8-54c2-47cb-94cd-e582bae9616c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Rajmahal Indian Cuisine and Bar",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2610, Overland Park, KS 66223, USA",
      "poi_short_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_long_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a9dd-7079-a5a4-f28d40a3970a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a9dd-7079-a5a4-f28d40a3970a",
        "storage_key": "property/6767906449167611/01a0b663-a9dd-7079-a5a4-f28d40a3970a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rajindiankc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3360016778443378904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rajmahal-indian-cuisine-and-bar",
      "poi_latitude": "38.88283",
      "poi_longitude": "-94.6503674",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-645-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4paqX3BwIcR2FB4NnUtoS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_6fc752e0-e741-4752-bede-1f4fd2a4b009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Darna Mediterranean Cuisine and Catering",
      "poi_type": "Restaurants",
      "poi_address": "15962 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Casual joint dishing up authentic Eastern Med eats such as hummus, shawarma, and kabobs alongside vegan options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a01010-3965-7658-ae35-457147de0c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-3965-7658-ae35-457147de0c93",
        "storage_key": "property/6767906449167611/01a01010-3965-7658-ae35-457147de0c93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.darnamediterranean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5586824929820216458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "darna-mediterranean-cuisine-and-catering",
      "poi_latitude": "38.839681",
      "poi_longitude": "-94.7821245",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-712-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZYC4CwC_wIcRigw7ZKxjiE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_8675f804-9739-45f9-a13d-5712098c4055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Carmen's Cocina II",
      "poi_type": "Restaurants",
      "poi_address": "15926 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Unassuming Mexican spot fixing up breakfast burritos, tacos & other typical fare in a small space.",
      "poi_long_description": "Unassuming Mexican spot fixing up breakfast burritos, tacos & other typical fare in a small space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-457d-73cd-af18-6b78750f8ff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-457d-73cd-af18-6b78750f8ff3",
        "storage_key": "property/6767906449167611/019fc98a-457d-73cd-af18-6b78750f8ff3.webp",
        "width": 977,
        "height": 1120
      },
      "poi_business_url": "http://www.carmenscocina2.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2498299266903269973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carmens-cocina-ii",
      "poi_latitude": "38.8396697",
      "poi_longitude": "-94.7814276",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-764-5855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsypsZPC-wIcRVWJjWvK9qyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9e80ac55-fdd1-40ce-ad89-7d305125837d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Bonito Michoacán",
      "poi_type": "Restaurants",
      "poi_address": "1231 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Butcher shop, bakery and store selling Mexican meat cuts, plus tacos and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a01010-3675-7618-bdbc-e280fa85b86e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-3675-7618-bdbc-e280fa85b86e",
        "storage_key": "property/6767906449167611/01a01010-3675-7618-bdbc-e280fa85b86e.webp",
        "width": 639,
        "height": 640
      },
      "poi_business_url": "http://bonitomichoacán.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800372171173904509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonito-michoacn",
      "poi_latitude": "38.8827407",
      "poi_longitude": "-94.7976309",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-768-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcX2Chu-wIcRfcDJlcYyRts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_9b21d1e6-4164-46c3-96c3-df753b73c66b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Golden Palace Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1711 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Long-running Chinese eatery serving classic meals in an unassuming, traditional space.",
      "poi_long_description": "Long-running Chinese eatery serving classic meals in an unassuming, traditional space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-48de-724c-a387-4742a62e3612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-48de-724c-a387-4742a62e3612",
        "storage_key": "property/6767906449167611/019fc98a-48de-724c-a387-4742a62e3612.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.goldenpalaceks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15371849164436339653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-palace-chinese-restaurant",
      "poi_latitude": "38.8560624",
      "poi_longitude": "-94.7805921",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdlrnlq-wIcRxfscG1_HU9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5dd49747-53ee-440b-9a22-9791ec2cd19d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "China Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2030 E Santa Fe St, Olathe, KS 66062, USA",
      "poi_short_description": "All-you-can-eat Chinese buffet offering noodles & sushi in a modest strip-mall setting.",
      "poi_long_description": "All-you-can-eat Chinese buffet offering noodles & sushi in a modest strip-mall setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a3b4-754c-bbc2-7ab0571d2895.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a3b4-754c-bbc2-7ab0571d2895",
        "storage_key": "property/6767906449167611/01a0b663-a3b4-754c-bbc2-7ab0571d2895.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chinabuffet.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130961632439374971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-buffet",
      "poi_latitude": "38.885063",
      "poi_longitude": "-94.7807514",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-393-0868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0UWwSW-wIcRexSd-2_5-9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_8d6283a6-0844-406e-a959-20273a6fd198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Strip's Chicken Express - Olathe",
      "poi_type": "Restaurants",
      "poi_address": "1110 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Quick-serve spot for chicken strips, pork burgers, custom salad bowls, shakes & mini donuts.",
      "poi_long_description": "Quick-serve spot for chicken strips, pork burgers, custom salad bowls, shakes & mini donuts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a36e-76e9-b968-c36634a96bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a36e-76e9-b968-c36634a96bea",
        "storage_key": "property/6767906449167611/01a0b663-a36e-76e9-b968-c36634a96bea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.stripschicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6138415347958582601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strips-chicken-express---olathe",
      "poi_latitude": "38.8839311",
      "poi_longitude": "-94.7999979",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-210-5170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7PJVRu-wIcRSY3gejwIMFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_241d3d43-b9f1-480d-a847-d621babc55e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Pizza Street",
      "poi_type": "Restaurants",
      "poi_address": "2018 E Santa Fe St, Olathe, KS 66062, USA",
      "poi_short_description": "Local Italian buffet chain offering pizza & pasta, plus a salad bar & dessert options.",
      "poi_long_description": "Local Italian buffet chain offering pizza & pasta, plus a salad bar & dessert options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a3a2-766e-ab35-241858026f33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a3a2-766e-ab35-241858026f33",
        "storage_key": "property/6767906449167611/01a0b663-a3a2-766e-ab35-241858026f33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pizzastreetbuffet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17189504669489339529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-street",
      "poi_latitude": "38.885164",
      "poi_longitude": "-94.781378",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-829-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwVkWwSW-wIcRiZzUSWxjje4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_ca1e09fc-f406-4998-a7b4-93fa6d28ffc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Red Crow Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1062 W Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-48e6-736a-b5c7-846079524f0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-48e6-736a-b5c7-846079524f0a",
        "storage_key": "property/6767906449167611/019fc98a-48e6-736a-b5c7-846079524f0a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://redcrowbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041481511854135563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-crow-brewing-company",
      "poi_latitude": "38.8843459",
      "poi_longitude": "-94.83278450000002",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-440-9852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUGfXUm6wIcRC9lT_YfLeX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_11411b4e-4ac0-4e50-afd9-c31ec5a7624e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "ROMEITO CUBAN RESTAURANT",
      "poi_type": "Restaurants",
      "poi_address": "111 N Parker St, Olathe, KS 66061, USA",
      "poi_short_description": "Familiar Latin-American-style eatery featuring Cuban classics like ropa vieja and ceviche, plus pastries, churros and flan.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6d6-0894-73c9-9d81-3663a7c8a263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-0894-73c9-9d81-3663a7c8a263",
        "storage_key": "property/6767906449167611/019ff6d6-0894-73c9-9d81-3663a7c8a263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://romeitocubanrestaurantks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7191294815029347088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "romeito-cuban-restaurant",
      "poi_latitude": "38.8817544",
      "poi_longitude": "-94.8354058",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-414-4241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaUQygim9wIcREMPufIiczGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3c0b4d82-b8d0-4a36-b2e7-3224917d3748",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Sake Lounge",
      "poi_type": "Restaurants",
      "poi_address": "11953 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Sushi is artfully presented, along with familiar Pan-Asian entrees, amid a hip, clubby atmosphere",
      "poi_long_description": "Sushi is artfully presented, along with familiar Pan-Asian entrees, amid a hip, clubby atmosphere",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a475-71d8-84c1-e98c4697aef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a475-71d8-84c1-e98c4697aef4",
        "storage_key": "property/6767906449167611/01a0b663-a475-71d8-84c1-e98c4697aef4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.sakeolathe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2381470504759816122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sake-lounge",
      "poi_latitude": "38.9092515",
      "poi_longitude": "-94.7663283",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZubJHWVwIcRum9Hd86uDCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_ebf5becf-8b55-4a60-be54-aeafbbff507c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "PepperJax Grill",
      "poi_type": "Restaurants",
      "poi_address": "1855 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Cheesesteaks & other sandwiches are ordered straight from the grill cook at this casual chain spot.",
      "poi_long_description": "Cheesesteaks & other sandwiches are ordered straight from the grill cook at this casual chain spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-a6b9-7364-b018-739c8a085143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-a6b9-7364-b018-739c8a085143",
        "storage_key": "property/6767906449167611/01a0b663-a6b9-7364-b018-739c8a085143.webp",
        "width": 1261,
        "height": 750
      },
      "poi_business_url": "https://pepperjaxgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10305904096870743343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pepperjax-grill",
      "poi_latitude": "38.9112112",
      "poi_longitude": "-94.7980883",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-815-3278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJob4BjMKVwIcRLz05TyztBY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7ef614fb-56c8-4a7a-92f2-3fc7c618c581",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "13600 S Alden St, Olathe, KS 66062, USA",
      "poi_short_description": "Grocery and home goods retailer selling household essentials, plus toys, clothing, electronics and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6d6-0dc5-760b-a795-01fde378aac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-0dc5-760b-a795-01fde378aac5",
        "storage_key": "property/6767906449167611/019ff6d6-0dc5-760b-a795-01fde378aac5.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/577-olathe-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8847812053339146437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8813311",
      "poi_longitude": "-94.7580085",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-829-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKfgVptq_wIcRxQizTi--yXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_305fac67-9471-4afd-ac6b-4d03036fd3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "18101 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "Neighborhood grocery store chain with prepared foods, a deli, and a pharmacy, plus online ordering and pickup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-afc0-74f5-993b-e3cfbfa11980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-afc0-74f5-993b-e3cfbfa11980",
        "storage_key": "property/6767906449167611/01a0b663-afc0-74f5-993b-e3cfbfa11980.webp",
        "width": 1086,
        "height": 764
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=501&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12797416529656855856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9110474",
      "poi_longitude": "-94.7951339",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-393-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1192-710b-8197-d83e2e838f11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1192-710b-8197-d83e2e838f11",
        "storage_key": "property/6767906449167611/019fc987-1192-710b-8197-d83e2e838f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxAxH8KVwIcRML3otIeOmbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b89b990a-ba10-4a6c-a942-a7ebfe170724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1075 W Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b2d8-701c-bc04-ebce8f52f8f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b2d8-701c-bc04-ebce8f52f8f3",
        "storage_key": "property/6767906449167611/01a0b663-b2d8-701c-bc04-ebce8f52f8f3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/olathe-ks-pharmacies/1075-w-santa-fe-street-olathe-ks-66061/storeid=5274?WT.mc_id=LS_GOOGLE_FS_5274",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308613993602837080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.8829527",
      "poi_longitude": "-94.8330054",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-764-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWnhe4u9wIcRWGpdCk38q0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_78d2ef97-dd44-491d-8e4e-87943451c951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "13450 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-6c26-7335-9507-54bab5a4ab8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6c26-7335-9507-54bab5a4ab8c",
        "storage_key": "property/6767906449167611/019fc98a-6c26-7335-9507-54bab5a4ab8c.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13450+s+blackbob+rd-olathe-ks-66062/id=4665",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796038198735279990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8843227",
      "poi_longitude": "-94.7616559",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-829-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3StTdC_wIcRdhfmTHQ6-PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d315e6eb-0f6a-488b-bf72-52696772f249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "16250 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b157-7023-ae0e-c2d42080d899.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b157-7023-ae0e-c2d42080d899",
        "storage_key": "property/6767906449167611/01a0b663-b157-7023-ae0e-c2d42080d899.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/ks/olathe-231.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9822339370780813415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "38.8850267",
      "poi_longitude": "-94.77371180000002",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ38j_Biy-wIcRZ2i54p31T4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_e41bb2c4-2b56-4169-b1aa-a7596aa159f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "14011 W 135th St, Olathe, KS 66062, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc986-eeb4-765a-bd2c-e2d44f0393aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-eeb4-765a-bd2c-e2d44f0393aa",
        "storage_key": "property/6767906449167611/019fc986-eeb4-765a-bd2c-e2d44f0393aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3343&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4463119196626745940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menards",
      "poi_latitude": "38.8816338",
      "poi_longitude": "-94.7489319",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-777-0147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu7YYgOe_wIcRVPopQUMv8D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ebb0b6f2-c723-4b6d-9fcd-46bae52f3801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Office Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "13509 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Chain selling office & school supplies, electronics & furniture (most featuring a copy center).",
      "poi_long_description": "Chain selling office & school supplies, electronics & furniture (most featuring a copy center).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b152-771f-afc4-42612aef60f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b152-771f-afc4-42612aef60f4",
        "storage_key": "property/6767906449167611/01a0b663-b152-771f-afc4-42612aef60f4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.officedepot.com/storelocator/ks/olathe/office-depot-650/?cm_mmc=GMB-_-650-_-Test-_-NS",
      "poi_directions_map_url": "https://maps.google.com/?cid=16779859106444669312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "office-depot",
      "poi_latitude": "38.8829011",
      "poi_longitude": "-94.7770537",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-393-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi6roCC--wIcRgPG8LPQI3ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_48226bcd-796a-4bf1-b7b8-9f1f559ff16e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Savers",
      "poi_type": "Shopping & Retail",
      "poi_address": "13509 S Mur-Len Rd #125a, Olathe, KS 66062, USA",
      "poi_short_description": "Thrift store chain offering secondhand clothing, footwear, furniture, books & household items.",
      "poi_long_description": "Thrift store chain offering secondhand clothing, footwear, furniture, books & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-5a20-76bb-93e0-e7101cf2dd66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-5a20-76bb-93e0-e7101cf2dd66",
        "storage_key": "property/6767906449167611/019fc98a-5a20-76bb-93e0-e7101cf2dd66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.savers.com/ks/olathe/savers-thrift-store-1145.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9639906812370690030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savers",
      "poi_latitude": "38.8825461",
      "poi_longitude": "-94.7770539",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-782-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi6roCC--wIcR7h854yvUx4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_4cc82344-a7da-4d9d-b6a0-3337064da6ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2130 E Santa Fe St, Olathe, KS 66062, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b1c0-77f9-b715-c49efe4227eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b1c0-77f9-b715-c49efe4227eb",
        "storage_key": "property/6767906449167611/01a0b663-b1c0-77f9-b715-c49efe4227eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/ks/olathe/2130-east-santa-fe?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=55764897936440346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "38.8852336",
      "poi_longitude": "-94.7803044",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-732-4139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfbKo7SW-wIcRGvxvFOEdxgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_5cf99bea-d429-425b-a972-6e149cbe97e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "112 N Clairborne Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b41a-7188-81cc-ce7a1f98d300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b41a-7188-81cc-ce7a1f98d300",
        "storage_key": "property/6767906449167611/01a0b663-b41a-7188-81cc-ce7a1f98d300.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ks/olathe/7805",
      "poi_directions_map_url": "https://maps.google.com/?cid=16579994977159601797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "38.8824259",
      "poi_longitude": "-94.7876865",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-732-4240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-49fd690320a0",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-49fd690320a0.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHb0yZCK-wIcRhd5bT5b5F-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_69855a77-5d67-4e00-9c77-f85492243496",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Indian Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "15800 Indian Creek Pkwy, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.olatheschools.org/indiancreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=1649699547313400445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-creek-elementary-school",
      "poi_latitude": "38.8920279",
      "poi_longitude": "-94.7686131",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-780-7510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjdsbjn-VwIcRfeq8b__o5BY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7b9d3aa4-3269-46c4-b5e5-f6b8ebf1ad54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Pioneer Trail Middle School",
      "poi_type": "Education",
      "poi_address": "15100 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/pioneertrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2058636432383380672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-trail-middle-school",
      "poi_latitude": "38.8992082",
      "poi_longitude": "-94.7643025",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-780-7270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6fYTI3qVwIcRwIzjme2-kRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_84e3a3f6-b99c-42ae-a25a-5940e69dc6b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe East High School",
      "poi_type": "Education",
      "poi_address": "14545 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6d6-10de-71b1-9712-b7810a87b452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-10de-71b1-9712-b7810a87b452",
        "storage_key": "property/6767906449167611/019ff6d6-10de-71b1-9712-b7810a87b452.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "http://www.olatheschools.org/east/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4226639083448974343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-east-high-school",
      "poi_latitude": "38.8956297",
      "poi_longitude": "-94.7538396",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg4KXUWGVwIcRBzzCStoJqDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_525ab2e7-b977-4f5e-b4c9-727c2dd7b857",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Mahaffie Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 N Nelson Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b46a-7074-881e-93d9eeff1506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b46a-7074-881e-93d9eeff1506",
        "storage_key": "property/6767906449167611/01a0b663-b46a-7074-881e-93d9eeff1506.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "http://www.olatheschools.org/mahaffie/",
      "poi_directions_map_url": "https://maps.google.com/?cid=397412615802508045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-elementary-school",
      "poi_latitude": "38.9033177",
      "poi_longitude": "-94.805968",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3paiOOVwIcRDdMqIqvkgwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6caba3f2-2a8f-46f2-a26e-53709213b90f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Indian Trail Middle School",
      "poi_type": "Education",
      "poi_address": "1440 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-5b4b-7632-b7a3-886f9b2f2546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-5b4b-7632-b7a3-886f9b2f2546",
        "storage_key": "property/6767906449167611/019ff6ad-5b4b-7632-b7a3-886f9b2f2546.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.olatheschools.org/indiantrail",
      "poi_directions_map_url": "https://maps.google.com/?cid=14951984620544489945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-trail-middle-school",
      "poi_latitude": "38.8556338",
      "poi_longitude": "-94.7954035",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-780-7230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ37m7Cnm-wIcR2XmoGssegM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8940cdf4-7e58-4c55-8ab7-42386f53f7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Heartland Early Child Center",
      "poi_type": "Education",
      "poi_address": "1700 W Sheridan St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/earlychildhood",
      "poi_directions_map_url": "https://maps.google.com/?cid=14744452281612459397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-early-child-center",
      "poi_latitude": "38.8723993",
      "poi_longitude": "-94.8457109",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-780-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI62B3Ju9wIcRhV01DTvRnsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_c8bceb31-9eb4-4b03-bf6f-4cb7fec432fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Special Beginnings Early Learning",
      "poi_type": "Education",
      "poi_address": "14169 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cadence-education.com/locations/ks/olathe/889/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15789845290112394999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "special-beginnings-early-learning",
      "poi_latitude": "38.8729464",
      "poi_longitude": "-94.7790098",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-393-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ40ha3zm-wIcR9yaGF6LMINs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_949c41e5-32ec-48c7-95c2-a106516f530e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Kiddie Academy of Olathe",
      "poi_type": "Education",
      "poi_address": "1585 S Mahaffie Cir, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-62ab-77af-a1de-0e9ab1c5207c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-62ab-77af-a1de-0e9ab1c5207c",
        "storage_key": "property/6767906449167611/019fc98a-62ab-77af-a1de-0e9ab1c5207c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/olathe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=440037305803804362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-olathe",
      "poi_latitude": "38.8563946",
      "poi_longitude": "-94.8061023",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-732-7773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbUt8uZ6_wIcRyg5bJJlTGwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_50aa0aff-e7dc-4209-8570-bf08fb0a963b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "MidAmerica Nazarene University",
      "poi_type": "Education",
      "poi_address": "2030 E College Way, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-0c0e-706c-a572-dd6228358e86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-0c0e-706c-a572-dd6228358e86",
        "storage_key": "property/6767906449167611/019fc987-0c0e-706c-a572-dd6228358e86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mnu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7871762714009878451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midamerica-nazarene-university",
      "poi_latitude": "38.8760668",
      "poi_longitude": "-94.7823676",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-782-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP7fBszu-wIcRsz-5ZHsePm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5fd85a93-1478-4a24-a1b4-f835b4d40efb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc986-ec57-718d-aab0-7309007c8658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-ec57-718d-aab0-7309007c8658",
        "storage_key": "property/6767906449167611/019fc986-ec57-718d-aab0-7309007c8658.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1997bf2b-b29e-45cf-aa98-a0d789ae4ea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "AMC Studio 28",
      "poi_type": "Entertainment",
      "poi_address": "12075 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Movie theater and dine-in eatery offering the latest releases, as well as a bar and snack counter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-63d2-7161-8836-f275dd571e41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-63d2-7161-8836-f275dd571e41",
        "storage_key": "property/6767906449167611/019fc98a-63d2-7161-8836-f275dd571e41.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-studio-28?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16780991066006934845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-studio-28",
      "poi_latitude": "38.907307",
      "poi_longitude": "-94.7671361",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-393-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-98b4-7760-a1c2-b182ebeed0c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-98b4-7760-a1c2-b182ebeed0c4",
        "storage_key": "property/6767906449167611/019fc98a-98b4-7760-a1c2-b182ebeed0c4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3tZuHWVwIcRPdVYDHcO4ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6601b74b-0d3a-4245-983a-47867148c243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Pinot's Palette",
      "poi_type": "Entertainment",
      "poi_address": "11945 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Attendees paint during evening classes at this art studio chain serving alcohol at most locations.",
      "poi_long_description": "Attendees paint during evening classes at this art studio chain serving alcohol at most locations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-b7be-735c-b90f-5964134c71b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-b7be-735c-b90f-5964134c71b5",
        "storage_key": "property/6767906449167611/01a0b663-b7be-735c-b90f-5964134c71b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pinotspalette.com/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14506328668447500930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinots-palette",
      "poi_latitude": "38.9096981",
      "poi_longitude": "-94.7663597",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-732-3768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMf0gP3WVwIcRgurg7RDVUMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_studio"
    },
    {
      "id": "custom_41ddea84-032d-4966-8310-68dd43b79a2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Main Event Olathe",
      "poi_type": "Restaurants",
      "poi_address": "11950 N Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Casual entertainment venue featuring laser tag and a rope course, plus bowling lanes and arcade-style video games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-638a-763b-89ca-0b60e84b1526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-638a-763b-89ca-0b60e84b1526",
        "storage_key": "property/6767906449167611/019fc98a-638a-763b-89ca-0b60e84b1526.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.mainevent.com/locations/kansas/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14851719059725861874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-olathe",
      "poi_latitude": "38.911748",
      "poi_longitude": "-94.7758366",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-768-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOURoFKKVwIcR8sPbCsznG84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_685633d4-a6b7-41db-b805-1b4caca56abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Mahaffie Stagecoach Stop-Farm",
      "poi_type": "Entertainment",
      "poi_address": "1200 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_long_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc986-f440-7554-a9e3-b481b8923970.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-f440-7554-a9e3-b481b8923970",
        "storage_key": "property/6767906449167611/019fc986-f440-7554-a9e3-b481b8923970.webp",
        "width": 1200,
        "height": 965
      },
      "poi_business_url": "http://www.mahaffie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906880325698000129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-stagecoach-stop-farm",
      "poi_latitude": "38.8920954",
      "poi_longitude": "-94.7996569",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-971-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1192-710b-8197-d6f3230e8e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1192-710b-8197-d6f3230e8e03",
        "storage_key": "property/6767906449167611/019fc987-1192-710b-8197-d6f3230e8e03.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f59bfeVwIcRARWVkKi9GEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d2f5f441-1891-4847-aa5a-b369db6dddc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Civic Theatre Association",
      "poi_type": "Entertainment",
      "poi_address": "500 E Loula St, Olathe, KS 66061, USA",
      "poi_short_description": "Theater and event-space venue, staging a variety of musical and comedic productions, from classics to current shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6d6-144e-7372-9893-4e2ff2116f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-144e-7372-9893-4e2ff2116f1a",
        "storage_key": "property/6767906449167611/019ff6d6-144e-7372-9893-4e2ff2116f1a.webp",
        "width": 604,
        "height": 402
      },
      "poi_business_url": "http://www.olathetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677147266849540730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-civic-theatre-association",
      "poi_latitude": "38.88076",
      "poi_longitude": "-94.81113",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-782-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9uSeP29wIcReoqVpI1sRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_99f27618-1b7b-4877-9e37-f860c2bea7bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "The Culture House",
      "poi_type": "Entertainment",
      "poi_address": "14808 W 117th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-befe-7743-9567-0aaa41a608f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-befe-7743-9567-0aaa41a608f5",
        "storage_key": "property/6767906449167611/01a0b663-befe-7743-9567-0aaa41a608f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.culturehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10480324979647492425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-culture-house",
      "poi_latitude": "38.9146493",
      "poi_longitude": "-94.7577412",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-393-3141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQXhXxKVwIcRSbGKtgqYcZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a187a1e1-cae1-4bc7-939b-55f1cc910608",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Museum of Deaf History, Arts and Culture",
      "poi_type": "Entertainment",
      "poi_address": "455 E Park St, Olathe, KS 66061, USA",
      "poi_short_description": "Museum with exhibits, historical information, events & workshops related to the hearing impaired.",
      "poi_long_description": "Museum with exhibits, historical information, events & workshops related to the hearing impaired.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a01010-47d6-74a8-8186-6dbb92138a60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-47d6-74a8-8186-6dbb92138a60",
        "storage_key": "property/6767906449167611/01a01010-47d6-74a8-8186-6dbb92138a60.webp",
        "width": 723,
        "height": 491
      },
      "poi_business_url": "http://www.museumofdeaf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17703514463863482569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-deaf-history-arts-and-culture",
      "poi_latitude": "38.88174950000001",
      "poi_longitude": "-94.8125358",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-324-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1192-710b-8197-d6f3230e8e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1192-710b-8197-d6f3230e8e03",
        "storage_key": "property/6767906449167611/019fc987-1192-710b-8197-d6f3230e8e03.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc18ypf29wIcRyaiSjpuEr_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6d78169f-b4c2-48c9-862a-06469665fa55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Lake Olathe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 S Lakeshore Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a beach, an obstacle course, a waterfall and cliffs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-72c7-7085-a118-e930b6bf4431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-72c7-7085-a118-e930b6bf4431",
        "storage_key": "property/6767906449167611/019fc98a-72c7-7085-a118-e930b6bf4431.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lake-olathe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6997584864379487297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olathe-park",
      "poi_latitude": "38.8735242",
      "poi_longitude": "-94.8731186",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-971-8973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtehEK9wIcRQUT9_ltqHGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6e5b3855-543c-4bd4-a3a5-c5058075dec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Premier Indoor Golf",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "25177 W 151st St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-bc35-760e-8dca-5bfe1f392cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-bc35-760e-8dca-5bfe1f392cc6",
        "storage_key": "property/6767906449167611/01a0b663-bc35-760e-8dca-5bfe1f392cc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://premierindoorgolf.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5916095735072105003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premier-indoor-golf",
      "poi_latitude": "38.8542276",
      "poi_longitude": "-94.8770683",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-222-9262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1191-7568-b1af-4615995f7df9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1191-7568-b1af-4615995f7df9",
        "storage_key": "property/6767906449167611/019fc987-1191-7568-b1af-4615995f7df9.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4M_D1C9wIcRKyIt6rkxGlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_golf_course"
    },
    {
      "id": "custom_45412ac2-0f8b-420a-a907-1a5a57324c3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Ernie Miller Park & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "909 North, KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_long_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-66fb-7345-9716-a79e6e750fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-66fb-7345-9716-a79e6e750fdc",
        "storage_key": "property/6767906449167611/019fc98a-66fb-7345-9716-a79e6e750fdc.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://erniemiller.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769145388029025309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernie-miller-park--nature-center",
      "poi_latitude": "38.8967913",
      "poi_longitude": "-94.8409835",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-826-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt22HnSWWwIcRHZwNByofEFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_9a22d1a5-e2c5-462f-90bf-733dcbbf36f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Health Family Medicine - Mur-Len",
      "poi_type": "Health and Wellness",
      "poi_address": "801 N Mur-Len Rd #201, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-6bba-744d-bbbf-b83a242d1d01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6bba-744d-bbbf-b83a242d1d01",
        "storage_key": "property/6767906449167611/019fc98a-6bba-744d-bbbf-b83a242d1d01.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.olathehealth.org/locations/olathe-health-family-medicine---mur-len",
      "poi_directions_map_url": "https://maps.google.com/?cid=9090584307258976631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-health-family-medicine---mur-len",
      "poi_latitude": "38.8932925",
      "poi_longitude": "-94.7800376",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-445-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdt5YI-VwIcRd2npckM-KH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_27602993-d6d4-4357-a9f8-bf54daedeaf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "20333 W 151st St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-695e-77b5-92d3-54619fad4e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-695e-77b5-92d3-54619fad4e5c",
        "storage_key": "property/6767906449167611/019fc98a-695e-77b5-92d3-54619fad4e5c.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/olathe-hospital?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16276948923291160757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-hospital",
      "poi_latitude": "38.85260299999999",
      "poi_longitude": "-94.822969",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-445-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a5-74cb-9fa4-b87a3e55bb3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a5-74cb-9fa4-b87a3e55bb3d",
        "storage_key": "property/6767906449167611/019fc987-11a5-74cb-9fa4-b87a3e55bb3d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQclTbs69wIcRtVDyh85W4-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_f68a8f41-4afe-4e11-b2b5-2ee1b7553cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Urgent Care, Blackfoot Medical Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "15435 W 134th Pl #101, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-ba74-71e9-b1e1-37892a792009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-ba74-71e9-b1e1-37892a792009",
        "storage_key": "property/6767906449167611/01a0b663-ba74-71e9-b1e1-37892a792009.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/urgent-care-blackfoot-medical-pavilion?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11950359307099950029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-blackfoot-medical-pavilion",
      "poi_latitude": "38.8844201",
      "poi_longitude": "-94.7646412",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-445-7520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDaiHkdO_wIcRzcv5XXk02KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c791ccb4-168c-4847-8e0e-528cde2f34e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1785 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-551f-76a3-9470-1d9d7e0c4f58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-551f-76a3-9470-1d9d7e0c4f58",
        "storage_key": "property/6767906449167611/019fc98a-551f-76a3-9470-1d9d7e0c4f58.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/olathe-ks-pharmacies/1785-s-mur-len-rd-olathe-ks-66062/storeid=5257?WT.mc_id=LS_GOOGLE_RX_5257",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868316038945963514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.855239",
      "poi_longitude": "-94.7806073",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-390-9892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-98b3-740f-bab8-0029e8c0f80e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-98b3-740f-bab8-0029e8c0f80e",
        "storage_key": "property/6767906449167611/019fc98a-98b3-740f-bab8-0029e8c0f80e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNRB-aVq-wIcR-v0NyNoD1JY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ec4cc35d-3583-4b5d-9918-157856f0a98c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "395 KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-bad1-703e-bac3-71ea95c29ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-bad1-703e-bac3-71ea95c29ce4",
        "storage_key": "property/6767906449167611/01a0b663-bad1-703e-bac3-71ea95c29ce4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4475-olathe-ks/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=870151484337720401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "38.886244",
      "poi_longitude": "-94.837983",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-764-7165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-98b3-740f-bab8-0029e8c0f80e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-98b3-740f-bab8-0029e8c0f80e",
        "storage_key": "property/6767906449167611/019fc98a-98b3-740f-bab8-0029e8c0f80e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLfsLhY29wIcRUYy6LCpmEww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1398f5e4-a6c2-4ff7-878e-acfafe39601c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13509 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Chain fitness center with tanning, massage chairs, and updated equipment, as well as knowledgeable trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc986-fa04-76d8-ab2f-b4d7834a6049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc986-fa04-76d8-ab2f-b4d7834a6049",
        "storage_key": "property/6767906449167611/019fc986-fa04-76d8-ab2f-b4d7834a6049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/olathe-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17119566753725212893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.8828221",
      "poi_longitude": "-94.777165",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-732-9350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0mRs72_wIcR3ehgWELrlO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a67238b4-ee35-47b4-9c71-b0575933a2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1473 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-bde6-730f-9990-87bad3ff54c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-bde6-730f-9990-87bad3ff54c3",
        "storage_key": "property/6767906449167611/01a0b663-bde6-730f-9990-87bad3ff54c3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/olathe-kansas-4211/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4211",
      "poi_directions_map_url": "https://maps.google.com/?cid=18377659993054209647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "38.8536538",
      "poi_longitude": "-94.7957355",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-971-4060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdVoEmS-wIcRb2bnCGWQCv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a5231b19-29e7-4266-be26-e39447b367a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20144 W 153rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-c244-77c6-bbca-f4283ea6b794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-c244-77c6-bbca-f4283ea6b794",
        "storage_key": "property/6767906449167611/01a0b663-c244-77c6-bbca-f4283ea6b794.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/olathe-kansas-0914?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=14333996050575716393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8517457",
      "poi_longitude": "-94.8185911",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-274-1415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV2eHK9K9wIcRKfBqlnaV7MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_14f3ed6a-a8c4-477e-9bc1-83d86a1e9fca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "YogaSix Olathe",
      "poi_type": "Health and Wellness",
      "poi_address": "15052 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Studio offering 6 different types of yoga classes, including hot and restorative varieties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-6d4b-730d-be5b-25676d30bdaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6d4b-730d-be5b-25676d30bdaa",
        "storage_key": "property/6767906449167611/019fc98a-6d4b-730d-be5b-25676d30bdaa.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "http://www.yogasix.com/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14096061170274182549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-olathe",
      "poi_latitude": "38.8559036",
      "poi_longitude": "-94.7621665",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-839-3154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKUivFNu_wIcRlaVeQvNEn8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_d26f8ed6-2032-48bc-bfdb-15e9972a9632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "21400 W 153rd St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-7da2-7112-ab45-c31470db1dd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-7da2-7112-ab45-c31470db1dd4",
        "storage_key": "property/6767906449167611/019ff6ad-7da2-7112-ab45-c31470db1dd4.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://kansascityymca.org/locations/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=3427068300167585099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-family-ymca",
      "poi_latitude": "38.8503418",
      "poi_longitude": "-94.8330142",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-393-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5ZPjxrW9wIcRS519LHZkjy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_1be9e047-7048-4256-bf53-83fdddf28f29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Two Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Locally popular outdoor spot featuring a baseball field, tennis courts and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-6f44-7364-92b4-557834611bda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6f44-7364-92b4-557834611bda",
        "storage_key": "property/6767906449167611/019fc98a-6f44-7364-92b4-557834611bda.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/two-trails-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8981433256265339244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-two-trails-park",
      "poi_latitude": "38.8952567",
      "poi_longitude": "-94.7958439",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3TyQPGVwIcRbFGT_fV1pHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_31f5c9ba-d10e-470b-96ff-573036ab67a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Prairie Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "555 N Olathe View Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_long_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-6f51-7207-8cbe-9968d5eafe85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-6f51-7207-8cbe-9968d5eafe85",
        "storage_key": "property/6767906449167611/019fc98a-6f51-7207-8cbe-9968d5eafe85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/parks/prairie-center-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1548584147364877856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-center-park",
      "poi_latitude": "38.8907907",
      "poi_longitude": "-94.8462045",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aiBfCmWwIcRIBZ8yBOtfRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a360a243-62eb-4c57-b26d-6abccda1082e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Frisco Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 E Dennis Ave, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a gazebo & playground, plus basketball & volleyball courts, walking trail & fishing.",
      "poi_long_description": "Park featuring a gazebo & playground, plus basketball & volleyball courts, walking trail & fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-71ea-722e-81dc-071ca106b381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-71ea-722e-81dc-071ca106b381",
        "storage_key": "property/6767906449167611/019ff6ad-71ea-722e-81dc-071ca106b381.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/frisco-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9704081886323539806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frisco-lake-park",
      "poi_latitude": "38.86967629999999",
      "poi_longitude": "-94.8023943",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbE4YAy-wIcRXv-dqQ_Tq4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e2cab92-7ba5-468a-bffe-84198db3ec8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Frontier Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15501 Indian Creek Pkwy, Olathe, KS 66062, USA",
      "poi_short_description": "22-acre community park featuring sports fields, a playground, green space & summer outdoor concerts.",
      "poi_long_description": "22-acre community park featuring sports fields, a playground, green space & summer outdoor concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-7200-74ff-badf-7114f91c2f12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-7200-74ff-badf-7114f91c2f12",
        "storage_key": "property/6767906449167611/019fc98a-7200-74ff-badf-7114f91c2f12.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/frontier-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13870060673232613758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frontier-park",
      "poi_latitude": "38.8929146",
      "poi_longitude": "-94.7649527",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0wuQ36VwIcRfjElEbJafMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_17f965a3-efb5-4b28-88ab-dad554390fca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Cedar Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15500 S Lone Elm Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Small lake featuring a playground, picnic facilities, and fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-8647-7448-a8ed-41ad61dc005d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-8647-7448-a8ed-41ad61dc005d",
        "storage_key": "property/6767906449167611/019ff6ad-8647-7448-a8ed-41ad61dc005d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/cedar-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993153085847633081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-lake",
      "poi_latitude": "38.8457194",
      "poi_longitude": "-94.8432857",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5S-S629wIcRufyndBUZznw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c46b1ae4-0672-4a2b-b339-d33a8a8394ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Black Bob Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14500 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_long_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-03ec-742f-9492-d8087f0e6d86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-03ec-742f-9492-d8087f0e6d86",
        "storage_key": "property/6767906449167611/019fc987-03ec-742f-9492-d8087f0e6d86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/black-bob-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317087441858333318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-bob-park",
      "poi_latitude": "38.8583619",
      "poi_longitude": "-94.7539901",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTqNmKS_wIcRhgoMG4_Nqlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c81aa751-f98c-4a0c-a2e7-ea7a5406f3e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Stagecoach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1205 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Large park featuring playgrounds and a 1-mile loop trail along with concerts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-8379-73e6-8444-40b1923375c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6ad-8379-73e6-8444-40b1923375c8",
        "storage_key": "property/6767906449167611/019ff6ad-8379-73e6-8444-40b1923375c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/stagecoach-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5736288166146146218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stagecoach-park",
      "poi_latitude": "38.889805",
      "poi_longitude": "-94.798939",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11e6-73d3-9643-e3c5dfe2a817",
        "storage_key": "property/6767906449167611/019fc987-11e6-73d3-9643-e3c5dfe2a817.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa3sGumVwIcRqv9q6LFjm08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5554d17d-2b6d-4a7a-93f8-89e5e36594c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Johnson County Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1701 W Old 56 Hwy, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-73e4-725f-a250-72810c861b34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-73e4-725f-a250-72810c861b34",
        "storage_key": "property/6767906449167611/019fc98a-73e4-725f-a250-72810c861b34.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/dept/transit/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259441942160797783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-transit",
      "poi_latitude": "38.8639984",
      "poi_longitude": "-94.8448333",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-362-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRjftqO9wIcRV_CsTkgB3lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_dd3d8162-e3a7-4128-9504-689faeb1d600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6d6-1e07-710e-938c-a9f092821022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d6-1e07-710e-938c-a9f092821022",
        "storage_key": "property/6767906449167611/019ff6d6-1e07-710e-938c-a9f092821022.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019ff6ad-99bf-7678-9b02-364e237ab0d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6ad-99bf-7678-9b02-364e237ab0d7",
        "storage_key": "property/6767906449167611/019ff6ad-99bf-7678-9b02-364e237ab0d7.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_a9c564cd-cb31-4f74-93ec-a11327c3f026",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Old 56 Family Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "912 S Chestnut St, Olathe, KS 66061, USA",
      "poi_short_description": "Old-fashioned eatery serving coffee, all-day breakfasts & homey diner classics in an updated space.",
      "poi_long_description": "Old-fashioned eatery serving coffee, all-day breakfasts & homey diner classics in an updated space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-47cd-749b-9aec-ee0f36fcee3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-47cd-749b-9aec-ee0f36fcee3f",
        "storage_key": "property/6767906449167611/019fc98a-47cd-749b-9aec-ee0f36fcee3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://olathe.old56familyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10586299816660311910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-56-family-restaurant",
      "poi_latitude": "38.868218",
      "poi_longitude": "-94.8182406",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-390-9905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11dc-7549-bb7b-835bd84c5f97",
        "storage_key": "property/6767906449167611/019fc987-11dc-7549-bb7b-835bd84c5f97.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzXmeee9wIcRZh_SOZgX6pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_e963a56f-7236-41f8-baf4-38c625bf861b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-98f2-7318-b5f7-2a18861c33c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc98a-98f2-7318-b5f7-2a18861c33c2",
        "storage_key": "property/6767906449167611/019fc98a-98f2-7318-b5f7-2a18861c33c2.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_7b0309f1-44d6-4d6e-8d4b-27e95dbff4af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Johnson County Executive Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "151st Street & Pflumm Road, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-0816-72ef-b6da-6579f4340ca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-0816-72ef-b6da-6579f4340ca2",
        "storage_key": "property/6767906449167611/019fc987-0816-72ef-b6da-6579f4340ca2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jocogov.org/dept/airport-commission/executive-airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=3226922393248729937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-executive-airport",
      "poi_latitude": "38.8543891",
      "poi_longitude": "-94.7351379",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-715-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-140e-77f9-bb2a-7faa398a4c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-140e-77f9-bb2a-7faa398a4c5c",
        "storage_key": "property/6767906449167611/019fc987-140e-77f9-bb2a-7faa398a4c5c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJZS5NLXi_wIcRUQtY19FUyCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_72ea28da-3d75-4af1-895e-d08037b32c6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-7bac-77fd-b3c1-edac7328e7ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-7bac-77fd-b3c1-edac7328e7ca",
        "storage_key": "property/6767906449167611/019fc98a-7bac-77fd-b3c1-edac7328e7ca.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "41.7",
      "poi_walking_minutes": "15 hours 28 mins",
      "poi_biking_minutes": "4 hours 21 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-140e-77f9-bb2a-7faa398a4c5c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-140e-77f9-bb2a-7faa398a4c5c",
        "storage_key": "property/6767906449167611/019fc987-140e-77f9-bb2a-7faa398a4c5c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_710803eb-cc2b-4f86-bd5d-b54bcb2d3995",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Midwest Trust Center",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_long_description": "Performing-arts center hosting a variety of concerts, dance performances & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-c99f-730a-865f-a7547232d627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-c99f-730a-865f-a7547232d627",
        "storage_key": "property/6767906449167611/01a0b663-c99f-730a-865f-a7547232d627.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jccc.edu/midwest-trust-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=333406106616415315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midwest-trust-center",
      "poi_latitude": "38.9252624",
      "poi_longitude": "-94.7279145",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-469-4445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRU0TRZhZ_oAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0586e73f-6c38-4906-abc7-75e14eb3025b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-0627-731e-8500-367237395762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc987-0627-731e-8500-367237395762",
        "storage_key": "property/6767906449167611/019fc987-0627-731e-8500-367237395762.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_98ee82ea-94f9-4100-acc6-aefc31033eea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-7cdc-7149-9848-3a26cbff1cc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-7cdc-7149-9848-3a26cbff1cc4",
        "storage_key": "property/6767906449167611/019fc98a-7cdc-7149-9848-3a26cbff1cc4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-1411-752b-accb-023099ac495a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-1411-752b-accb-023099ac495a",
        "storage_key": "property/6767906449167611/019fc987-1411-752b-accb-023099ac495a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_ea17ff6e-c7de-4da4-af9b-f03dcd83d13d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Farmers Insurance - Jon Wren Agency",
      "poi_type": "Major Employers & Offices",
      "poi_address": "234 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-8075-75ac-ae14-9248d81ffdec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-8075-75ac-ae14-9248d81ffdec",
        "storage_key": "property/6767906449167611/019fc98a-8075-75ac-ae14-9248d81ffdec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://jonwrenagency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10511535783564524590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farmers-insurance---jon-wren-agency",
      "poi_latitude": "38.8793015",
      "poi_longitude": "-94.8191804",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-839-8422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9iIOw2VwIcRLrwrRxp64JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_1ea73419-0c60-451d-8944-fc93bb3a2fec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Husqvarna Construction Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17400 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "Construction company offering quality equipment along with training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-820e-743f-8c52-8c3407de2b49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-820e-743f-8c52-8c3407de2b49",
        "storage_key": "property/6767906449167611/019fc98a-820e-743f-8c52-8c3407de2b49.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.husqvarna.com/us/construction/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15077997571752706308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "husqvarna-construction-products",
      "poi_latitude": "38.9148372",
      "poi_longitude": "-94.7878107",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-928-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoRx0GL-VwIcRBMGFpOfOP9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_499a197e-6567-4d41-99d4-2378ae7e2b99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Grundfos",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17100 118th Terrace, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.grundfos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3813339895108642031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grundfos",
      "poi_latitude": "38.9157167",
      "poi_longitude": "-94.7830362",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-994-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRSoYd-VwIcR76TGP2606zQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a06a33be-3b16-4f2d-a9a4-9505b4bb85a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Honeywell Aerospace, Olathe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "23500 W 105th St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-8126-7778-b8ab-0fe7e55e9e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-8126-7778-b8ab-0fe7e55e9e06",
        "storage_key": "property/6767906449167611/019fc98a-8126-7778-b8ab-0fe7e55e9e06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://honeywellaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17457818006217975346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell-aerospace-olathe",
      "poi_latitude": "38.93807",
      "poi_longitude": "-94.8562769",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-712-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWE9C-SXwIcRMmYKLvugRvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_1ce16bd8-abff-4323-9448-28fb2fabdcad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Olathe Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14160 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc98a-7e0c-735e-af6c-1554c8297548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98a-7e0c-735e-af6c-1554c8297548",
        "storage_key": "property/6767906449167611/019fc98a-7e0c-735e-af6c-1554c8297548.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.olatheschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2471559516784985002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-public-schools",
      "poi_latitude": "38.8710187",
      "poi_longitude": "-94.7620475",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-780-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11a4-76bb-9622-bd96972fc311",
        "storage_key": "property/6767906449167611/019fc987-11a4-76bb-9622-bd96972fc311.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAyR-Mci_wIcRqoM0H0m-TCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2342daa4-2b2c-4922-9887-ceb2d142a6b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "poi_name": "Amazon MCI5",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16851 W 113th St, Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-cc45-7429-a9d7-fcf11240b6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b663-cc45-7429-a9d7-fcf11240b6be",
        "storage_key": "property/6767906449167611/01a0b663-cc45-7429-a9d7-fcf11240b6be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17188903443457799781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-mci5",
      "poi_latitude": "38.921271",
      "poi_longitude": "-94.782689",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-254-8971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc987-11d9-778e-bed7-fa5323a38694",
        "storage_key": "property/6767906449167611/019fc987-11d9-778e-bed7-fa5323a38694.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxK666-VwIcRZXbKcZxAi-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    }
  ],
  "office_hours": [
    {
      "id": "ec_108c3258a5d0fdea5e4b0e76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c82de98e576116005897ef2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bbded5a9871b600d51ead7ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_637cacb0a57c6b02311891b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_52622c6bb73941d4291c8251",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b36d60e50ba53a0c10efc8c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_46e2cf470e809c5c354662c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "rating": "5",
      "name": "Brian Miller",
      "text": "Maintenance staff is always professional and quiet and quick. Issue was fixed within an hour of my request sent to the office. Great staff.",
      "date": "2026-04-13",
      "title": "false"
    },
    {
      "id": "ec_c7e639f6414edfab5fcf1221",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "rating": "5",
      "name": "Cecilia Dresser",
      "text": "10/10 recommend living here! Logan made my application and move-in process a breeze. He is so kind and always makes sure I'm taken care of. The rest of the office staff has also been helpful and kind. Maintenance took care of my requests quickly and thoroughly resolved them. The property is very well kept and I never have any issues. Add on a great location and being reasonably priced for the area; you can't beat it.",
      "date": "2025-03-24",
      "title": "false"
    },
    {
      "id": "ec_1d610cbda8ae20d6f078ecca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "rating": "5",
      "name": "Brian Mick",
      "text": "I can't recommend Somerset Oaks Apartments enough! From the moment I moved in, I've been impressed by the professionalism and friendliness of the entire staff.  The leasing team, especially Logan Gray, made the application process smooth and stress-free. They answered all my questions patiently and thoroughly.\n\nThe apartments themselves are impeccably maintained. My unit is spacious and well-lit, and the grounds are always clean and inviting. The pool is a real bonus, and it's clear that management takes pride in keeping everything in top condition.\n\nBut what truly sets Somerset Oaks Apartments apart is the staff. Every interaction, whether it's with maintenance, the front desk, or anyone else, has been positive. They're always courteous, prompt, and genuinely helpful. I had an electrical issue awhile back and they fixed it promptly. It feels like they truly care about the residents' well-being and creating a positive living environment.\n\nIf you're looking for a clean, comfortable, and well-managed apartment complex with a fantastic staff, look no further than Somerset Oaks Apartments ! You won't be disappointed",
      "date": "2024-07-09",
      "title": "false"
    },
    {
      "id": "ec_8d3f95f8186b7c3a989aa162",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "rating": "5",
      "name": "Daisy Bobbitt",
      "text": "I will never stop reviewing how amazing the staff at this apartment community is. The lead maintenance Jon is a superstar, Michaela and Michele are the best property managers you will ever find, and the the leasing staff are always so quick to answer and assist with any requests. I could not get more lucky as a resident living here. This is the best apartment community I have ever lived in and I will be here for a very long time.",
      "date": "2024-10-16",
      "title": "false"
    },
    {
      "id": "ec_a8936c7f521e7da166f47450",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "rating": "5",
      "name": "Gail Huffman",
      "text": "I love Somerset Oaks! I lived here for several years and had a great experience. The staff is kind and helpful and I loved my apartment. I rarely had to report any maintenance issues, but when I did maintenance was on top of it! Having a garage to keep my car out of the elements and for extra storage was priceless to me. It's also right down the street from restaurants and shopping which was so nice. Highly recommend!",
      "date": "2024-07-19",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_8ed3548dd484ee1a970ff63f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-d850-7056-b265-fe1dfe18d383.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b663-d850-7056-b265-fe1dfe18d383",
        "storage_key": "property/6767906449167611/01a0b663-d850-7056-b265-fe1dfe18d383.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Chelsea",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yK8NTySoSzy"
    },
    {
      "id": "ec_5e93f5051baf523499ad5800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-e908-7026-a98d-59836ec12e02.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b663-e908-7026-a98d-59836ec12e02",
        "storage_key": "property/6767906449167611/01a0b663-e908-7026-a98d-59836ec12e02.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cheshire",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9Q5RGnQhJi7"
    },
    {
      "id": "ec_f0f04d3f2634bbc0e2fe34cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-edad-71c8-a059-a3ccac202814.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b663-edad-71c8-a059-a3ccac202814",
        "storage_key": "property/6767906449167611/01a0b663-edad-71c8-a059-a3ccac202814.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Hampton",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZUAgmDReFX2"
    },
    {
      "id": "ec_a3be75a9cf013b09fba4bb59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-d942-701f-b008-1cbf549cd331.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b663-d942-701f-b008-1cbf549cd331",
        "storage_key": "property/6767906449167611/01a0b663-d942-701f-b008-1cbf549cd331.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Yorkshire",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4QDJfvR9mfY"
    },
    {
      "id": "ec_022418006211fd42533a89d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b663-d8c9-735b-9262-36813b5ac8dd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b663-d8c9-735b-9262-36813b5ac8dd",
        "storage_key": "property/6767906449167611/01a0b663-d8c9-735b-9262-36813b5ac8dd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Windsor",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=TwFhew6vqi1"
    },
    {
      "id": "ec_4a1de314e48cfb5eb974d7b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167611/01a0b664-0802-7798-ad45-035d8eea2e5b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b664-0802-7798-ad45-035d8eea2e5b",
        "storage_key": "property/6767906449167611/01a0b664-0802-7798-ad45-035d8eea2e5b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Somerset",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QtAo4g8eGHW"
    }
  ],
  "faqs": [
    {
      "id": "custom_123008e1-2902-4158-a03f-af9a6e19b9cf",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_8e3e8fa0-3e4a-4a83-ac94-4b16e3dd7c86",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d6d21e32-8cd6-4643-9af8-423022b46739",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d7d30309-ff5b-4b62-b3ee-213d0d6f6cba",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8c845270-2174-4962-96ff-92ea7ee87ecb",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_bfa36556-759f-4144-9c02-d5e7f5b04bd4",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3a24d3df-ad79-4d3a-805c-0e8a353fb011",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_30323f10-abd6-40f4-bf62-7aec50fc0a25",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8571a057-1ec2-47d8-b60a-4f720c1a7e7c",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e5b6209d-494b-4b0a-b2f7-484a6f4995e9",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2d96d355-d6c4-47d9-b04c-c961f87bdd01",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d6c2e8ac-b911-440a-8db9-e6d750f72d73",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c343548a-ff50-4c05-9cb8-343a0d66074f",
      "question": "Do you offer covered parking?",
      "answer": "Yes. Our community offers select apartment homes with attached garages. We also offer carports, detached, and breezeway garages. <a href=\"/contact-us\">Contact our office</a> for pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_68a9b4f2-c513-442d-831c-1a6dd46980d3",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b17f808d-9ec7-4b4b-9b67-ac03e92ab830",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_d661a193-7744-4bdc-8824-3ccd3d83d9ef",
      "question": "Can I rent the clubhouse for a private event?",
      "answer": "We do not accept clubhouse reservations for private events at this time. However, we do host an array of community events for our residents! Please <a href=\"/contact-us\">contact our leasing office</a> for more information.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_04932027-a8ce-442c-8de3-8af3da3a6e2f",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-4593-721f-b165-b297b860e5fe",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Somerset Oaks Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611"
    },
    {
      "lead_collector_id": "01a0c9ac-4627-759f-9dd0-167ac1d68d51",
      "lead_source": "LANDING_PAGE",
      "name": "Somerset Oaks Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-olathe-ks",
      "search_query": "apartments with in-unit laundry in Olathe KS",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Olathe KS",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry in Olathe. Enjoy Somerset Oaks Apartment Homes' amenities today.",
      "page_copy": "Experience the ultimate convenience at Somerset Oaks Apartment Homes, where apartments with in-unit laundry in Olathe KS redefine comfortable living. Our one-, two-, and three-bedroom homes offer not only washer/dryer connections but also beautiful polished finishes. Enjoy the freedom of doing laundry at home without any hassle.\n\nLocated in the heart of Olathe, Somerset Oaks takes pride in offering modern features like private patios, vaulted ceilings, and Wi-Fi, all enveloped in a community that's perfect for relaxation. From breathtaking views to essential conveniences, experience the ease of apartment living with everything you need just at hand. Book a tour today and discover how Somerset Oaks exemplifies modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Olathe, KS",
      "seo_description": "Explore Somerset Oaks for in-unit laundry apartments in Olathe, KS with modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-near-66062",
      "search_query": "air conditioned apartments near 66062",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 66062",
      "h2_subtitle": "Stay comfortable year-round in air conditioned apartments near 66062. Somerset Oaks offers the perfect living environment.",
      "page_copy": "Somerset Oaks Apartment Homes provide a refreshing living experience with air conditioned apartments near 66062. Enjoy comfortable and modern living spaces that keep you cool during the hot months. Our one-, two-, and three-bedroom homes feature not only air conditioning but also a host of premium features such as polished finishes and private outdoor spaces.\n\nOur community is nestled in the charming city of Olathe, delivering a convenient lifestyle thanks to nearby amenities and attractions. Somerset Oaks is more than just a place to live; it's a community where comfort meets style. Complete with washer/dryer connections and stunning views, it's the ideal place to unwind and embrace the good life. Tour Somerset Oaks today and discover the perfect blend of comfort and convenience in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 66062",
      "seo_description": "Find air conditioned apartments near 66062 at Somerset Oaks. Explore our amenities and schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartment-with-pool-olathe",
      "search_query": "apartment with a pool in Olathe",
      "category": "Amenity",
      "h1_title": "Apartment with a Pool in Olathe",
      "h2_subtitle": "Dive into relaxation at an apartment with a pool in Olathe. Somerset Oaks offers exceptional living and leisure options.",
      "page_copy": "Imagine coming home to an oasis at Somerset Oaks Apartment Homes, featuring an inviting apartment with a pool in Olathe. Our community provides a refreshing escape with top-tier amenities designed to enhance your lifestyle. Whether you're lounging by the pool or taking a dip on a sunny day, Somerset Oaks ensures your leisure time is well spent.\n\nIn addition to the pool, our one-, two-, and three-bedroom apartments are equipped with modern conveniences such as private patios, vaulted ceilings, and in-unit laundry connections. Nestled in Olathe, Somerset Oaks combines convenience and comfort within reach of local attractions and everyday essentials. Experience unparalleled apartment living and relaxation by the pool at Somerset Oaks today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with a Pool in Olathe",
      "seo_description": "Enjoy an apartment with a pool in Olathe at Somerset Oaks. Discover our amenities and schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-with-garages-johnson-county",
      "search_query": "apartments with garages in Johnson County",
      "category": "Amenity",
      "h1_title": "Apartments with Garages in Johnson County",
      "h2_subtitle": "Secure your vehicle with apartments offering garages in Johnson County. Discover Somerset Oaks today.",
      "page_copy": "At Somerset Oaks Apartment Homes, find peace of mind with apartments featuring garages in Johnson County. Offering secure parking options, our community enhances your convenience and lifestyle. With our selection of one-, two-, and three-bedroom units, residents enjoy the luxury of private garage spaces along with other sought-after amenities.\n\nCentrally located in the vibrant area of Olathe, Somerset Oaks combines modern living with practical benefits. Alongside garage facilities, enjoy in-unit convenience with washer/dryer connections, spacious patios, and vaulted ceilings—a perfect setting for a comfortable and stylish lifestyle. Schedule your tour today to explore how our apartments in Johnson County fulfill all your living needs while providing added security for your vehicle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Garages in Johnson County",
      "seo_description": "Discover Somerset Oaks' apartments with garages in Johnson County. Explore our amenities and secure a spacious home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "dishwasher-equipped-apartments-somerset-oaks",
      "search_query": "dishwasher equipped apartments in Somerset Oaks",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments at Somerset Oaks",
      "h2_subtitle": "Enjoy convenience with dishwasher equipped apartments in Somerset Oaks. Experience hassle-free living today.",
      "page_copy": "Discover the joys of modern living with dishwasher equipped apartments at Somerset Oaks in Olathe. Our community is designed with your convenience in mind, offering essential features that streamline daily chores. Inside our one-, two-, and three-bedroom homes, you'll find dishwashers ready to make mealtime clean-up a breeze.\n\nBeyond kitchen conveniences, Somerset Oaks provides a welcoming environment with features like private outdoor spaces and elevated interiors. Take advantage of amenities including Wi-Fi and stunning views that enhance the living experience. Located conveniently in Johnson County, our community is perfect for those looking to enjoy a serene lifestyle without compromising on modern necessities. Schedule a tour today and see why Somerset Oaks is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments at Somerset Oaks",
      "seo_description": "Find Somerset Oaks apartments with dishwashers. Experience ultimate convenience in modern living. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-olathe-ks",
      "search_query": "one bedroom apartments in Olathe KS",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Olathe, KS",
      "h2_subtitle": "Discover ideal one bedroom apartments in Olathe, KS at Somerset Oaks. Experience comfort and convenience in a vibrant community.",
      "page_copy": "Explore the spacious one bedroom apartments in Olathe, KS, at Somerset Oaks Apartment Homes. Our thoughtfully designed layouts maximize living space and offer modern comforts that cater to a variety of lifestyles. Enjoy features like private patios, vaulted ceilings, and washer/dryer connections that ensure a comfortable and pleasant living experience.\n\nLocated in the charming area of Olathe, Somerset Oaks blends convenience with tranquility, perfect for anyone searching for a peaceful retreat within Johnson County. Our community amenities, including free Wi-Fi and scenic views, complement the inviting interiors of our one bedroom apartments. Discover the perfect balance of style and function at Somerset Oaks—schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Olathe, KS",
      "seo_description": "Discover ideal one bedroom apartments in Olathe, KS at Somerset Oaks. Schedule a tour to find your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-somerset-oaks-johnson-county",
      "search_query": "two bedroom apartments Somerset Oaks Johnson County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments at Somerset Oaks",
      "h2_subtitle": "Find spacious two-bedroom apartments at Somerset Oaks in Johnson County, featuring modern interiors and convenient community amenities.",
      "page_copy": "Discover two-bedroom apartments at Somerset Oaks Apartment Homes in Johnson County, Olathe, Kansas. These apartments feature spacious layouts, private patios or balconies, vaulted ceilings, and washer and dryer connections, combining functional spaces with modern finishes.\n\nThe community offers amenities such as high-speed Wi-Fi and scenic views. Located in Olathe, Somerset Oaks provides convenient access to nearby shopping, dining, schools, and local destinations. Explore two-bedroom apartments with practical features and community amenities at Somerset Oaks Apartment Homes. Contact the leasing team to schedule a tour.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Olathe at Somerset Oaks",
      "seo_description": "Explore two bedroom apartments at Somerset Oaks, Johnson County. Perfect for a spacious and comfortable living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-66062",
      "search_query": "three bedroom apartments near 66062",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 66062",
      "h2_subtitle": "Find spacious three-bedroom apartments near 66062 at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "page_copy": "Discover three-bedroom apartments near the 66062 ZIP code at Somerset Oaks Apartment Homes in Olathe, Kansas. These apartments feature spacious layouts, private patios, vaulted ceilings, and washer and dryer connections, offering functional spaces with modern finishes.\n\nLocated in Johnson County, Somerset Oaks offers community amenities and convenient access to nearby shopping, dining, schools, and local destinations. Explore three-bedroom apartments with practical features and comfortable living spaces at Somerset Oaks Apartment Homes. Schedule a tour to learn more about available floor plans and community amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 66062",
      "seo_description": "Find spacious three-bedroom apartments near 66062 at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-near-indian-creek-elementary-olathe",
      "search_query": "apartments near indian creek elementary school olathe",
      "category": "School",
      "h1_title": "Apartments Near Indian Creek Elementary",
      "h2_subtitle": "Discover apartments near Indian Creek Elementary School in Olathe, featuring modern apartment features and convenient access to local amenities.",
      "page_copy": "Somerset Oaks Apartment Homes offers apartments near Indian Creek Elementary School in Olathe, Kansas. Apartment features include private patios, vaulted ceilings, and washer and dryer connections, providing functional spaces for everyday living.\n\nLocated in Johnson County, the community offers amenities such as high-speed Wi-Fi and scenic views. Residents can also explore nearby schools, local attractions, shopping, and dining options. With convenient access to destinations throughout Olathe, Somerset Oaks offers a range of apartment features and community amenities. Schedule a tour to explore the community and available floor plans.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Indian Creek Elementary Olathe",
      "seo_description": "Discover apartments near Indian Creek Elementary School in Olathe at Somerset Oaks, featuring community amenities and convenient access to local destinations.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "somerset-oaks-apartments-by-pioneer-trail-middle",
      "search_query": "somerset oaks apartments by pioneer trail middle school",
      "category": "School",
      "h1_title": "Somerset Oaks by Pioneer Trail Middle",
      "h2_subtitle": "Explore apartments at Somerset Oaks in Olathe near Pioneer Trail Middle School, featuring modern interiors and convenient community amenities.",
      "page_copy": "Somerset Oaks Apartment Homes offers one-, two-, and three-bedroom apartments near Pioneer Trail Middle School in Olathe, Kansas. Each apartment features modern amenities, including private patios and washer and dryer connections.\n\nThe community offers high-speed Wi-Fi and landscaped views, along with convenient access to nearby schools, shopping, dining, and local attractions. Located in Olathe, Somerset Oaks combines functional apartment features with community amenities for everyday living. Schedule a tour to explore the available floor plans and discover more about Somerset Oaks Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Somerset Oaks by Pioneer Trail Middle School",
      "seo_description": "Discover apartments at Somerset Oaks in Olathe near Pioneer Trail Middle School, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "olathe-east-high-school-nearby-apartments",
      "search_query": "olathe east high school nearby apartments",
      "category": "School",
      "h1_title": "Olathe East High School Nearby Apartments",
      "h2_subtitle": "Find apartments near Olathe East High School at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "page_copy": "Somerset Oaks Apartment Homes offers apartments near Olathe East High School in Johnson County, Kansas. The community features a variety of floor plans with private balconies or patios, vaulted ceilings, and washer and dryer connections.\n\nResidents can also enjoy community amenities such as high-speed Wi-Fi and scenic views. Located in Olathe, Somerset Oaks provides convenient access to nearby schools, shopping, dining, and local destinations. Explore the apartment features and community amenities at Somerset Oaks Apartment Homes, and schedule a tour to learn more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe East High School Nearby Apartments",
      "seo_description": "Discover apartments near Olathe East High School at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "mahaffie-elementary-school-close-by-apartments",
      "search_query": "mahaffie elementary school close by apartment options",
      "category": "School",
      "h1_title": "Apartments Near Mahaffie Elementary School",
      "h2_subtitle": "Discover apartments near Mahaffie Elementary School in Olathe at Somerset Oaks, featuring modern apartment interiors and convenient community amenities.",
      "page_copy": "Somerset Oaks Apartment Homes offers one-, two-, and three-bedroom apartments near Mahaffie Elementary School in Olathe, Kansas. Each apartment features modern finishes, private patios, and washer and dryer connections, providing functional spaces for everyday living.\n\nCommunity amenities include Wi-Fi access and scenic views. Located in Olathe, Somerset Oaks provides convenient access to nearby schools, shopping, dining, and local attractions throughout the area. Explore the available floor plans and community amenities at Somerset Oaks Apartment Homes, and schedule a tour to learn more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mahaffie Elementary School",
      "seo_description": "Explore apartments near Mahaffie Elementary School at Somerset Oaks in Olathe, featuring modern interiors and convenient access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "indian-trail-middle-school-apartments-johnson-county",
      "search_query": "indian trail middle school apartment homes in johnson county",
      "category": "School",
      "h1_title": "Apartment Homes by Indian Trail Middle School",
      "h2_subtitle": "Discover modern apartment homes near Indian Trail Middle School in Johnson County. Experience Somerset Oaks' inviting community.",
      "page_copy": "Somerset Oaks Apartment Homes offers apartments near Indian Trail Middle School in Johnson County, Kansas. The community features modern floor plans with stylish finishes, private patios, and washer and dryer connections.\n\nResidents can enjoy community amenities such as high-speed Wi-Fi and scenic views. Located in Johnson County, Somerset Oaks also provides access to nearby schools, shopping, dining, and local destinations throughout the area. Explore the apartment features and community amenities at Somerset Oaks Apartment Homes, conveniently located near Indian Trail Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Indian Trail Middle School",
      "seo_description": "Find apartments near Indian Trail Middle School at Somerset Oaks in Johnson County, featuring modern apartment interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "midamerica-nazarene-university-nearby-apartments",
      "search_query": "midamerica nazarene university nearby apartment listings",
      "category": "School",
      "h1_title": "Apartments Near MidAmerica Nazarene University",
      "h2_subtitle": "Explore apartments near MidAmerica Nazarene University at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "page_copy": "Somerset Oaks Apartment Homes offers one-, two-, and three-bedroom apartments in Olathe, Kansas, near MidAmerica Nazarene University. Apartment features include modern finishes, private balconies or patios, and washer and dryer connections.\n\nCommunity amenities include Wi-Fi access and scenic views. Located in Johnson County, Somerset Oaks provides convenient access to the university, nearby shopping, dining, and other local destinations. Explore the available floor plans and community amenities at Somerset Oaks Apartment Homes, conveniently located near MidAmerica Nazarene University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MidAmerica Nazarene University in Olathe",
      "seo_description": "Discover apartments near MidAmerica Nazarene University at Somerset Oaks in Olathe, featuring modern interiors and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "jccc-neighboring-apartments-olathe",
      "search_query": "johnson county community college neighboring apartments olathe",
      "category": "School",
      "h1_title": "Apartments Near JCCC in Olathe",
      "h2_subtitle": "Find neighboring apartments to Johnson County Community College in Olathe. Explore Somerset Oaks today.",
      "page_copy": "Conveniently located near Johnson County Community College, Somerset Oaks Apartment Homes offers excellent apartment options for students and professionals in Olathe. Enjoy the proximity to JCCC with our thoughtfully designed one-, two-, and three-bedroom homes featuring modern amenities like private patios, vaulted ceilings, and washer/dryer connections.\n\nExperience a sense of community and tranquility at Somerset Oaks, where stunning views and Wi-Fi access make day-to-day living enjoyable. Our apartments provide an ideal base for both academic and lifestyle pursuits while being close enough to the college for a quick commute. Discover the perfect mix of comfort and accessibility by visiting Somerset Oaks today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near JCCC in Olathe",
      "seo_description": "Explore neighboring apartment options near Johnson County Community College at Somerset Oaks in Olathe, offering convenience and quality living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-near-lake-olathe-park",
      "search_query": "apartments near Lake Olathe Park",
      "category": "Park",
      "h1_title": "Relaxed Apartment Living Near Lake Olathe Park",
      "h2_subtitle": "Discover apartments near Lake Olathe Park, offering a peaceful and scenic lifestyle. Explore Somerset Oaks today.",
      "page_copy": "Located near Lake Olathe Park, Somerset Oaks Apartment Homes offers one-, two-, and three-bedroom apartments in Olathe, Kansas. The community provides convenient access to outdoor recreation, walking trails, and park amenities.\n\nApartment features include modern finishes, natural light, and private outdoor spaces such as balconies or patios. Community amenities include high-speed Wi-Fi and landscaped views. With access to Lake Olathe Park and nearby shopping, dining, and local destinations, Somerset Oaks combines practical apartment features with opportunities to enjoy the outdoors.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Relaxed Apartment Living Near Lake Olathe Park",
      "seo_description": "Experience serene living at Somerset Oaks, with apartments near Lake Olathe Park offering natural beauty and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "somerset-oaks-near-olathe-two-trails-park",
      "search_query": "Somerset Oaks apartments close to Olathe Two Trails Park",
      "category": "Park",
      "h1_title": "Somerset Oaks by Two Trails Park",
      "h2_subtitle": "Explore Somerset Oaks Apartments, close to Olathe's Two Trails Park. Perfect for park lovers seeking convenience.",
      "page_copy": "Somerset Oaks Apartment Homes offers a prime location for those wanting to live near Olathe’s vibrant Two Trails Park. This apartment community boasts a blend of convenience and outdoor access, making it ideal for those who cherish time in nature. With the park just moments away, residents can enjoy leisurely strolls and outdoor activities right at their doorstep.\n\nOur one-, two-, and three-bedroom apartment homes invite you to experience spacious living with amenities like washer/dryer connections, private patios, and vaulted ceilings. The community also features Wi-Fi access and scenic views, making it a perfect retreat after a day at the park. Discover how Somerset Oaks offers the best in lifestyle and location by scheduling a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Somerset Oaks by Two Trails Park",
      "seo_description": "Discover Somerset Oaks, perfectly located close to Olathe's Two Trails Park. Enjoy convenience and park access in these spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "prairie-center-park-nearby-apartments-johnson-county",
      "search_query": "Prairie Center Park nearby apartments in Johnson County",
      "category": "Park",
      "h1_title": "Apartments near Prairie Center Park",
      "h2_subtitle": "Find the ideal apartments nearby Prairie Center Park in Johnson County at Somerset Oaks. Discover the perfect blend of nature and convenience.",
      "page_copy": "Located in the heart of Johnson County, Somerset Oaks Apartment Homes gives you immediate access to the beautiful Prairie Center Park. Enjoy the convenience of having this expansive park practically in your backyard, offering a wealth of amenities from walking trails to open recreational spaces.\n\nAt Somerset Oaks, we offer a range of one-, two-, and three-bedroom apartment homes designed for comfort and style. Our amenities include Wi-Fi, private balconies or patios, and vaulted ceilings. Whether you're an outdoor enthusiast or enjoy serene views from your window, our community presents an unbeatable blend of comfort and location. Visit Somerset Oaks today and explore our proximity to the natural beauty of Prairie Center Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments near Prairie Center Park",
      "seo_description": "Discover nearby apartments in Johnson County at Somerset Oaks, close to Prairie Center Park and offering both nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-near-frisco-lake-park-olathe",
      "search_query": "apartments near Frisco Lake Park Olathe",
      "category": "Park",
      "h1_title": "Live Near Frisco Lake Park Olathe",
      "h2_subtitle": "Discover Somerset Oaks Apartments, perfectly situated near Frisco Lake Park in Olathe. Ideal for outdoor enthusiasts and city dwellers alike.",
      "page_copy": "Find your ideal home at Somerset Oaks Apartment Homes, where the scenic beauty of Frisco Lake Park in Olathe adds tranquility to everyday living. Experience the joy of having a picturesque outdoor retreat just steps from your door, perfect for jogging, picnics, and leisurely walks.\n\nOur community boasts stylish one-, two-, and three-bedroom apartments featuring amenities like private patios or balconies and vaulted ceilings, designed for both comfort and style. Complemented by washer/dryer connections and high-speed Wi-Fi, Somerset Oaks combines modern convenience with natural beauty. Visit us today to see why our apartments offer the perfect balance of proximity to Frisco Lake Park and contemporary living in Olathe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Frisco Lake Park Olathe",
      "seo_description": "Explore apartments near Frisco Lake Park in Olathe at Somerset Oaks, offering the convenience of both nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "somerset-oaks-near-frontier-park-recreational",
      "search_query": "Somerset Oaks near Frontier Park recreational activities",
      "category": "Park",
      "h1_title": "Somerset Oaks by Frontier Park Fun",
      "h2_subtitle": "Experience Somerset Oaks, located near Olathe's Frontier Park. Enjoy easy access to abundant recreational activities and relaxation spots.",
      "page_copy": "At Somerset Oaks Apartment Homes, explore an active lifestyle with Frontier Park’s recreational activities right nearby. This prime Olathe location provides easy access to a wide array of outdoor fun, from sports fields to scenic walking trails, making it a hub for those who love being active.\n\nChoose from our selection of one-, two-, and three-bedroom apartments, featuring well-appointed amenities such as private patios or balconies, vaulted ceilings, and in-unit washer/dryer connections. Wi-Fi access and scenic views enhance the comfort, creating a perfect home base for adventurers and relaxation seekers alike. Schedule a visit today and discover how Somerset Oaks perfectly complements the active lifestyle offered by Frontier Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Somerset Oaks by Frontier Park Fun",
      "seo_description": "Discover Somerset Oaks near Frontier Park with easy access to recreational activities and modern apartments perfect for active lifestyles.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "cedar-lake-nearby-olathe-apartment-living",
      "search_query": "Cedar Lake nearby Olathe apartment living",
      "category": "Park",
      "h1_title": "Cedar Lake Living in Olathe",
      "h2_subtitle": "Explore apartment living near Cedar Lake at Somerset Oaks in Olathe. Perfect for nature lovers seeking modern comfort.",
      "page_copy": "Situated near the scenic Cedar Lake, Somerset Oaks Apartment Homes offers a unique blend of tranquility and modern living in Olathe. Enjoy the serene beauty of nearby Cedar Lake, a perfect spot for relaxation, fishing, and picnicking, just moments away from your living space.\n\nOur community provides spacious one-, two-, and three-bedroom apartment homes featuring stylish amenities such as private patios or balconies and vaulted ceilings. High-speed Wi-Fi and washer/dryer connections enhance the convenience of living here. Enjoy the best of both worlds at Somerset Oaks: modern apartment living combined with the natural beauty of Cedar Lake, ensuring a peaceful and fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Lake Living in Olathe",
      "seo_description": "Experience apartment living near Cedar Lake in Olathe at Somerset Oaks, combining nature's tranquility with modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-close-to-black-bob-park-66062",
      "search_query": "apartments close to Black Bob Park in 66062",
      "category": "Park",
      "h1_title": "Live Near Black Bob Park, 66062",
      "h2_subtitle": "Discover Somerset Oaks Apartments, ideally located close to Black Bob Park in 66062. Enjoy unmatched access to outdoor delights.",
      "page_copy": "Experience the ultimate convenience of living at Somerset Oaks Apartment Homes, positioned near Black Bob Park in the 66062 area of Olathe. This location provides fantastic opportunities for outdoor recreation, with expansive playgrounds, walking trails, and sports facilities just a short distance away.\n\nOur apartments offer upscale living with one-, two-, and three-bedroom floor plans, each featuring modern amenities such as private patios or balconies and vaulted ceilings. High-speed Wi-Fi and washer/dryer connections add convenience to everyday life, making Somerset Oaks the perfect home base for those who love easy access to nature and recreation at Black Bob Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Black Bob Park, 66062",
      "seo_description": "Find the perfect apartment close to Black Bob Park in 66062 at Somerset Oaks, offering great proximity to outdoor activities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "stagecoach-park-nearby-apartments-olathe",
      "search_query": "Stagecoach Park nearby apartments in Olathe",
      "category": "Park",
      "h1_title": "Apartments Near Stagecoach Park",
      "h2_subtitle": "Discover Somerset Oaks Apartments in Olathe, conveniently located near Stagecoach Park. Enjoy community amenities and nearby green spaces.",
      "page_copy": "Nestled near the welcoming green expanse of Stagecoach Park, Somerset Oaks Apartment Homes in Olathe offers a blend of vibrant living and serene surroundings. With the park's playgrounds, walking paths, and picnic areas just minutes away, residents can enjoy outdoor relaxation and recreation right at their doorstep.\n\nSomerset Oaks provides spacious one-, two-, and three-bedroom apartments designed for comfort and style. Enjoy modern amenities including private patios or balconies, vaulted ceilings, and washer/dryer connections to enhance your living experience. With Wi-Fi available throughout the community, Somerset Oaks is ideal for those who seek the perfect balance of apartment living and access to nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Stagecoach Park",
      "seo_description": "Explore Somerset Oaks, offering apartments in Olathe close to Stagecoach Park, providing a harmonious blend of community amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167611",
      "source": "custom",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near Kansas City International Airport",
      "category": "Transit",
      "h1_title": "Proximity to Kansas City Airport",
      "h2_subtitle": "Somerset Oaks in Olathe offers convenient apartments near Kansas City International Airport, blending comfort with accessibility.",
      "page_copy": "For those seeking a convenient location close to Kansas City International Airport, Somerset Oaks Apartment Homes in Olathe presents an ideal choice. Although the airport is easily accessible, residents can enjoy the suburban tranquility away from city noise while benefiting from swift travel options. \n\nChoose from our thoughtfully designed one-, two-, and three-bedroom apartments equipped with modern amenities like private outdoor spaces, vaulted ceilings, and in-unit washer/dryer connections. With seamless Wi-Fi connectivity and a peaceful community setting, Somerset Oaks ensures that comfort and accessibility are at the forefront of your living experience, while making air travel a breeze.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
        "public_id": "019fc987-b91b-727b-bd81-a749861f186d",
        "storage_key": "property/6767906449167611/019fc987-b91b-727b-bd81-a749861f186d.webp",
        "width": 1200,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Proximity to Kansas City Airport",
      "seo_description": "Discover Somerset Oaks Apartments in Olathe, offering close proximity to Kansas City International Airport, perfect for frequent travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701891844"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WB6KLCJX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 9"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/d9c36fae-0fff-43e0-9462-3b2e821bf9d1/app.js?nocache=1&gaTracking=G-L3J55N44ZT&buttonbgcolor=ad841f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-423-2955"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ikhtb1M5SkR5a1g0Wlk0Y1JwZE51dlE9PSIsInZhbHVlIjoiWTZVeEJYVHB6UGFTS01NaXoyRnp3Zz09IiwibWFjIjoiN2YxNWIwZTcxYzFjZjJkMjBkNzZlZTlhZWE1YjdlZWNjNzA0MDliZTMyZmViY2UyNTdiOGQ2NjMwZjY3YzRhOCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701891844",
  "custom_google_gtm_id": "GTM-WB6KLCJX",
  "custom_rollout_phase": "Batch 9",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/d9c36fae-0fff-43e0-9462-3b2e821bf9d1/app.js?nocache=1&gaTracking=G-L3J55N44ZT&buttonbgcolor=ad841f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-423-2955",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ikhtb1M5SkR5a1g0Wlk0Y1JwZE51dlE9PSIsInZhbHVlIjoiWTZVeEJYVHB6UGFTS01NaXoyRnp3Zz09IiwibWFjIjoiN2YxNWIwZTcxYzFjZjJkMjBkNzZlZTlhZWE1YjdlZWNjNzA0MDliZTMyZmViY2UyNTdiOGQ2NjMwZjY3YzRhOCJ9",
  "custom_audioeye_site_id": "bda1bc4f-a1f2-4eb2-ad17-8497bad61307",
  "custom_audioeye_site_hash": "2fffcc53b518e8a6f65efcf3bb1efb4a"
};

export const generatedAt = '2026-11-03T22:57:40.515Z';
